import * as React from "react";

const HeroImage = () => (
  <svg
    width={1021}
    height={650}
    viewBox="0 0 1021 650"
    className="w-full"
    style={{
      height: "auto",
      paddingRight: "0px",
      marginRight: "0px",
    }}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <style>
      {`
      @keyframes spin {
        from {
          transform: rotate(0deg);
        }

        to {
          transform: rotate(360deg);
        }
      }

      @keyframes translate {

        0%,
        to {
          transform: translateX(0)
        }

        50% {
          transform: translateX(24px)
        }
      }

      @keyframes translate2 {

        0%,
        to {
          transform: translateX(0)
        }

        50% {
          transform: translateX(-24px)
        }
      }

      @media(prefers-reduced-motion: no-preference) {
        .cog {
          animation: spin 20000ms linear 0s infinite;
          transform-origin: 53.8% 85.69%;
        }

        .switchToggle1 {
          animation: translate 3000ms ease-in .5s infinite;
        }

        .switchToggle2 {
          animation: translate2 3000ms ease-in 0s infinite;
        }

      }
   `}
    </style>
    <g id="Frame_595">
      <g id="Group" opacity={0.2}>
        <path
          id="Shape"
          d="M999.062 225.12h-1.174v-20.37c-.263-2.46-.587-4.9-.972-7.32v27.69h-28.092v-33.16h27.137c-.079-.38-.149-.75-.228-1.13h-26.909v-33.17h14.668c-.21-.37-.438-.75-.674-1.12h-13.994v-17.21c-.324-.29-.648-.6-.981-.89v18.1h-30.045v-33.17h6.361c-.893-.39-1.787-.76-2.689-1.12h-3.672v-1.39c-.324-.11-.648-.22-.972-.32v1.71h-29.073v-7.73c-.324-.04-.657-.06-.981-.09v7.82h-29.064v-7.54c-.324.02-.657.06-.981.1v7.44h-29.064v-2.65c-.324.06-.657.13-.981.21v2.44H835.44c-1.664.37-3.329.75-4.994 1.12h16.236v33.17h-29.064v-30.29c-.332.06-.657.14-.981.21v30.08h-29.064v-24.69c-.332.05-.657.09-.981.13v24.56h-29.063v-22.77c-.324 0-.658-.02-.981-.02v22.79h-29.064v-27.02c-.324-.06-.658-.16-.981-.25v27.27h-29.064v-33.17h9.962c-1.025-.37-2.033-.73-3.049-1.12h-6.913v-2.69c-.324-.13-.649-.25-.981-.39v3.08h-29.064v-16.09c-.324-.14-.657-.3-.981-.45v16.54h-29.064v-30c-.333-.14-.657-.29-.981-.42v30.42h-29.064V89.08h22.614c-.911-.37-1.822-.75-2.733-1.12h-19.881v-7.17c-.324-.12-.657-.21-.981-.31v7.48h-29.064V73.9c-.324-.05-.657-.09-.981-.15v14.21h-29.064V71.02c-.333-.02-.657-.02-.981-.02v16.96h-29.064V71.73c-.333.02-.657.04-.981.08v16.15h-29.073V76.04c-.324.06-.648.12-.972.21v11.71H457.07v-3.84c-.324.11-.648.23-.972.34v3.5h-9.656c-.946.37-1.893.75-2.839 1.12h12.495v33.17h-29.073V96.41c-.324.17-.648.32-.972.48v25.36H396.98v-8.6c-.324.21-.648.43-.972.66v7.94H384.81c-.491.37-.981.75-1.481 1.12h12.679v33.17h-29.072v-19.71c-.325.28-.649.57-.973.86v18.85h-19.285c-.351.37-.692.75-1.043 1.12h20.328v33.17h-29.072v-23.31c-.333.37-.657.75-.973 1.13v22.18h-17.112c-.254.38-.517.75-.78 1.13h17.892v33.16h-29.072v-16.06c-.333.54-.657 1.08-.982 1.61v14.45h-8.245c-.201.38-.403.75-.596 1.13h8.841v33.16h-24.779c-.166.38-.324.75-.49 1.13h25.269v33.17h-29.063V269.5c-.333.79-.657 1.58-.982 2.36v21.85h-8.648c-.14.37-.289.73-.429 1.12h9.077V328h-21.537c-.14.36-.28.75-.42 1.11h21.957v33.18h-29.063v-14.48c-.324.84-.649 1.69-.981 2.52v11.96h-4.741c-.149.36-.306.75-.455 1.11h5.196v33.18h-19.794c-.184.36-.359.75-.552 1.11h20.346v33.17h-29.064v-16.07c-.324.6-.649 1.21-.981 1.82v14.25h-8.035c-.219.37-.438.74-.657 1.12h8.692v33.17h-29.134v-2.05c-.324.46-.649.9-.982 1.33v.72h-.534c-.272.37-.552.75-.832 1.12h1.366v33.17h-29.063v-.96c-.701.71-1.402 1.41-2.103 2.08h1.122v33.19h-29.064v-9.57c-.324.23-.657.47-.981.71v8.86H112.39c-.578.37-1.156.75-1.735 1.1h14.87v33.19H96.461V543.6c-.324.21-.657.4-.981.61v23.83H66.416v-5.94c-.333.21-.657.42-.981.65v5.29h-7.79c-.525.35-1.051.73-1.568 1.1h9.358v33.19H36.37V585c-.333.31-.657.6-.981.91v16.42H20.109c-.307.36-.605.73-.894 1.11H35.39v33.17H6.326v-13.4c-.333.64-.666 1.27-.981 1.93v11.47H.395c-.141.39-.272.75-.395 1.12h5.345v11.57h.981v-11.57H35.39v11.57h.981v-11.57h29.064v11.57h.981v-11.57H95.48v11.57h.98v-11.57h29.065v11.57h.981v-11.57h29.064v11.57h.981v-11.57h29.063v11.57h.982v-11.57h29.134v11.57h.981v-11.57h29.064v11.57h.981v-11.57h29.063v11.57h.982v-11.57h29.063v11.57h.982v-11.57h29.072v11.57h.973v-11.57h29.072v11.57h.973v-11.57h29.072v11.57h.972v-11.57h29.073v11.57h.972v-11.57h29.073v11.57h.972v-11.57h29.073v11.57h.972v-11.57h29.073v11.57h.981v-11.57h29.064v11.57h.981v-11.57h29.064v11.57h.981v-11.57h29.064v11.57h.981v-11.57h29.064v11.57h.981v-11.57h29.064v11.57h.981v-11.57h29.064v11.57h.981v-11.57h29.064v10.19a8.54 8.54 0 00.981-.28v-9.91h29.063v.77c.324-.11.658-.23.982-.36v-.41h1.165c1.043-.36 2.085-.73 3.119-1.12h-4.284v-33.17h29.063v23.41c.333-.14.657-.29.982-.43v-22.98h29.063v9.35c.324-.17.657-.33.982-.5v-8.85h16.98c.57-.36 1.122-.73 1.665-1.11h-18.646v-33.19h29.064v26.72c.324-.21.657-.42.982-.65v-26.07h26.057c.211-.37.422-.74.614-1.1h-26.672v-33.19h29.064v28.04c.35-.89.675-1.79.981-2.72v-25.32h1.788c-.053-.37-.096-.74-.149-1.1h-1.639v-9.6c-.315-1.65-.648-3.3-.981-4.96v14.56h-29.064v-33.19h26.164c-.018-.38-.026-.75-.044-1.12h-26.12v-33.17h29.064v13.88c.307-.9.631-1.82.981-2.72v-11.16h5.442c.219-.37.438-.75.666-1.12h-6.108v-33.17h29.064v4.81c.324-.33.648-.67.981-1v-3.81h3.777c.368-.38.744-.75 1.121-1.12h-4.898v-33.17h29.073v9.21c.324-.34.648-.69.972-1.03v-8.18H945c.307-.38.605-.75.903-1.11h-8.105V363.4h28.231c.184-.36.369-.75.561-1.11h-28.792v-33.18h30.045v30.64c.333-.67.657-1.34.981-2.02v-28.62h12.031c.131-.36.271-.75.403-1.11h-12.434v-33.17h22.221c.096-.37.184-.75.263-1.12h-22.484v-33.17h28.091v1.35c.377-3.06.702-6.14.973-9.22v-26.42h1.183c0-.38-.009-.75-.009-1.13zM65.435 636.61H36.37v-33.17h29.064v33.17zm30.045 0H66.416v-33.17H95.48v33.17zm0-34.28H66.416v-33.19H95.48v33.19zm30.045 34.28H96.461v-33.17h29.064v33.17zm0-34.28H96.461v-33.19h29.064v33.19zm30.045 34.28h-29.064v-33.17h29.064v33.17zm0-34.28h-29.064v-33.19h29.064v33.19zm0-34.29h-29.064v-33.19h29.064v33.19zm30.044 68.57h-29.063v-33.17h29.063v33.17zm0-34.28h-29.063v-33.19h29.063v33.19zm0-34.29h-29.063v-33.19h29.063v33.19zm0-34.29h-29.063v-33.19h29.063v33.19zm30.116 102.86h-29.134v-33.17h29.134v33.17zm0-34.28h-29.134v-33.19h29.134v33.19zm0-34.29h-29.134v-33.19h29.134v33.19zm0-34.29h-29.134v-33.19h29.134v33.19zm0-34.31h-29.134v-33.17h29.134v33.17zm30.045 137.17h-29.064v-33.17h29.064v33.17zm0-34.28h-29.064v-33.19h29.064v33.19zm0-34.29h-29.064v-33.19h29.064v33.19zm0-34.29h-29.064v-33.19h29.064v33.19zm0-34.31h-29.064v-33.17h29.064v33.17zm0-34.29h-29.064v-33.17h29.064v33.17zm30.044 171.46h-29.063v-33.17h29.063v33.17zm0-34.28h-29.063v-33.19h29.063v33.19zm0-34.29h-29.063v-33.19h29.063v33.19zm0-34.29h-29.063v-33.19h29.063v33.19zm0-34.309h-29.063V466.27h29.063v33.171zm0-34.29h-29.063V431.98h29.063v33.171zm0-34.29h-29.063V397.69h29.063v33.171zm0-34.28h-29.063V363.4h29.063v33.181zm30.045 240.03h-29.063V603.44h29.063v33.171zm0-34.28h-29.063V569.14h29.063v33.191zm0-34.29h-29.063V534.85h29.063v33.191zm0-34.29h-29.063V500.56h29.063v33.191zm0-34.31h-29.063V466.27h29.063v33.171zm0-34.29h-29.063V431.98h29.063v33.171zm0-34.29h-29.063V397.69h29.063v33.171zm0-34.28h-29.063V363.4h29.063v33.181zm0-34.29h-29.063V329.11h29.063v33.181zm0-34.29h-29.063V294.83h29.063v33.171zm30.054 308.609h-29.072v-33.17h29.072v33.17zm0-34.28h-29.072v-33.19h29.072v33.19zm0-34.29h-29.072v-33.19h29.072v33.19zm0-34.29h-29.072v-33.19h29.072v33.19zm0-34.31h-29.072v-33.17h29.072v33.17zm0-34.29h-29.072v-33.17h29.072v33.17zm0-34.29h-29.072v-33.17h29.072v33.17zm0-34.28h-29.072V363.4h29.072v33.18zm0-34.29h-29.072v-33.18h29.072v33.18zm0-34.29h-29.072v-33.17h29.072V328zm0-34.29h-29.072v-33.17h29.072v33.17zm0-34.3h-29.072v-33.16h29.072v33.16zm30.045 377.2h-29.072v-33.17h29.072v33.17zm0-34.28h-29.072v-33.19h29.072v33.19zm0-34.29h-29.072v-33.19h29.072v33.19zm0-34.29h-29.072v-33.19h29.072v33.19zm0-34.309h-29.072V466.27h29.072v33.171zm0-34.29h-29.072V431.98h29.072v33.171zm0-34.29h-29.072V397.69h29.072v33.171zm0-34.28h-29.072V363.4h29.072v33.181zm0-34.29h-29.072V329.11h29.072v33.181zm0-34.29h-29.072V294.83h29.072v33.171zm0-34.29h-29.072V260.54h29.072v33.171zm0-34.3h-29.072V226.25h29.072v33.161zm0-34.29h-29.072V191.96h29.072v33.161zm30.045 411.49h-29.072V603.44h29.072v33.171zm0-34.28h-29.072V569.14h29.072v33.191zm0-34.29h-29.072V534.85h29.072v33.191zm0-34.29h-29.072V500.56h29.072v33.191zm0-34.31h-29.072V466.27h29.072v33.171zm0-34.29h-29.072V431.98h29.072v33.171zm0-34.29h-29.072V397.69h29.072v33.171zm0-34.28h-29.072V363.4h29.072v33.181zm0-34.29h-29.072V329.11h29.072v33.181zm0-34.29h-29.072V294.83h29.072v33.171zm0-34.29h-29.072V260.54h29.072v33.171zm0-34.3h-29.072V226.25h29.072v33.161zm0-34.29h-29.072V191.96h29.072v33.161zm0-34.29h-29.072V157.66h29.072v33.171zm30.045 445.78H396.98V603.44h29.073v33.171zm0-34.28H396.98V569.14h29.073v33.191zm0-34.29H396.98V534.85h29.073v33.191zm0-34.29H396.98V500.56h29.073v33.191zm0-34.31H396.98V466.27h29.073v33.171zm0-34.29H396.98V431.98h29.073v33.171zm0-34.29H396.98V397.69h29.073v33.171zm0-34.28H396.98V363.4h29.073v33.181zm0-34.29H396.98V329.11h29.073v33.181zm0-34.29H396.98V294.83h29.073v33.171zm0-34.29H396.98V260.54h29.073v33.171zm0-34.299H396.98V226.25h29.073v33.162zm0-34.29H396.98V191.96h29.073v33.162zm0-34.29H396.98V157.66h29.073v33.172zm0-34.29H396.98V123.37h29.073v33.172zm30.045 480.068h-29.073v-33.17h29.073v33.17zm0-34.28h-29.073v-33.19h29.073v33.19zm0-34.29h-29.073v-33.19h29.073v33.19zm0-34.29h-29.073v-33.19h29.073v33.19zm0-34.31h-29.073v-33.17h29.073v33.17zm0-34.29h-29.073v-33.17h29.073v33.17zm0-34.29h-29.073v-33.17h29.073v33.17zm0-34.28h-29.073V363.4h29.073v33.18zm0-34.29h-29.073v-33.18h29.073v33.18zm0-34.29h-29.073v-33.17h29.073V328zm0-34.29h-29.073v-33.17h29.073v33.17zm0-34.3h-29.073v-33.16h29.073v33.16zm0-34.29h-29.073v-33.16h29.073v33.16zm0-34.29h-29.073v-33.17h29.073v33.17zm0-34.29h-29.073v-33.17h29.073v33.17zm30.045 480.07H457.07v-33.17h29.073v33.17zm0-34.28H457.07v-33.19h29.073v33.19zm0-34.29H457.07v-33.19h29.073v33.19zm0-34.29H457.07v-33.19h29.073v33.19zm0-34.31H457.07v-33.17h29.073v33.17zm0-34.29H457.07v-33.17h29.073v33.17zm0-34.29H457.07v-33.17h29.073v33.17zm0-34.28H457.07V363.4h29.073v33.18zm0-34.29H457.07v-33.18h29.073v33.18zm0-34.29H457.07v-33.17h29.073V328zm0-34.29H457.07v-33.17h29.073v33.17zm0-34.3H457.07v-33.16h29.073v33.16zm0-34.29H457.07v-33.16h29.073v33.16zm0-34.29H457.07v-33.17h29.073v33.17zm0-34.29H457.07v-33.17h29.073v33.17zm0-34.29H457.07V89.08h29.073v33.17zm30.045 514.36h-29.073v-33.17h29.073v33.17zm0-34.28h-29.073v-33.19h29.073v33.19zm0-34.29h-29.073v-33.19h29.073v33.19zm0-34.29h-29.073v-33.19h29.073v33.19zm0-34.31h-29.073v-33.17h29.073v33.17zm0-34.29h-29.073v-33.17h29.073v33.17zm0-34.29h-29.073v-33.17h29.073v33.17zm0-34.28h-29.073V363.4h29.073v33.18zm0-34.29h-29.073v-33.18h29.073v33.18zm0-34.29h-29.073v-33.17h29.073V328zm0-34.29h-29.073v-33.17h29.073v33.17zm0-34.3h-29.073v-33.16h29.073v33.16zm0-34.29h-29.073v-33.16h29.073v33.16zm0-34.29h-29.073v-33.17h29.073v33.17zm0-34.29h-29.073v-33.17h29.073v33.17zm0-34.29h-29.073V89.08h29.073v33.17zm30.045 514.361h-29.064V603.44h29.064v33.171zm0-34.28h-29.064V569.14h29.064v33.191zm0-34.29h-29.064V534.85h29.064v33.191zm0-34.29h-29.064V500.56h29.064v33.191zm0-34.31h-29.064V466.27h29.064v33.171zm0-34.29h-29.064V431.98h29.064v33.171zm0-34.29h-29.064V397.69h29.064v33.171zm0-34.28h-29.064V363.4h29.064v33.181zm0-34.29h-29.064V329.11h29.064v33.181zm0-34.29h-29.064V294.83h29.064v33.171zm0-34.29h-29.064V260.54h29.064v33.171zm0-34.3h-29.064V226.25h29.064v33.161zm0-34.29h-29.064V191.96h29.064v33.161zm0-34.29h-29.064V157.66h29.064v33.171zm0-34.29h-29.064V123.37h29.064v33.171zm0-34.29h-29.064v-33.17h29.064v33.17zm30.045 514.36h-29.064V603.44h29.064v33.171zm0-34.28h-29.064V569.14h29.064v33.191zm0-34.29h-29.064V534.85h29.064v33.191zm0-34.29h-29.064V500.56h29.064v33.191zm0-34.31h-29.064V466.27h29.064v33.171zm0-34.29h-29.064V431.98h29.064v33.171zm0-34.29h-29.064V397.69h29.064v33.171zm0-34.28h-29.064V363.4h29.064v33.181zm0-34.29h-29.064V329.11h29.064v33.181zm0-34.29h-29.064V294.83h29.064v33.171zm0-34.29h-29.064V260.54h29.064v33.171zm0-34.3h-29.064V226.25h29.064v33.161zm0-34.29h-29.064V191.96h29.064v33.161zm0-34.29h-29.064V157.66h29.064v33.171zm0-34.29h-29.064V123.37h29.064v33.171zm0-34.29h-29.064v-33.17h29.064v33.17zm30.045 514.361h-29.064V603.44h29.064v33.172zm0-34.28h-29.064V569.14h29.064v33.192zm0-34.29h-29.064V534.85h29.064v33.192zm0-34.29h-29.064V500.56h29.064v33.192zm0-34.31h-29.064V466.27h29.064v33.172zm0-34.29h-29.064V431.98h29.064v33.172zm0-34.29h-29.064V397.69h29.064v33.172zm0-34.28h-29.064V363.4h29.064v33.182zm0-34.29h-29.064V329.11h29.064v33.182zm0-34.29h-29.064V294.83h29.064v33.172zm0-34.29h-29.064V260.54h29.064v33.172zm0-34.3h-29.064V226.25h29.064v33.162zm0-34.29h-29.064V191.96h29.064v33.162zm0-34.29h-29.064V157.66h29.064v33.172zm0-34.29h-29.064V123.37h29.064v33.172zm0-34.29h-29.064V89.08h29.064v33.172zm30.045 514.36h-29.064V603.44h29.064v33.172zm0-34.28h-29.064V569.14h29.064v33.192zm0-34.29h-29.064V534.85h29.064v33.192zm0-34.29h-29.064V500.56h29.064v33.192zm0-34.31h-29.064V466.27h29.064v33.172zm0-34.29h-29.064V431.98h29.064v33.172zm0-34.29h-29.064V397.69h29.064v33.172zm0-34.28h-29.064V363.4h29.064v33.182zm0-34.29h-29.064V329.11h29.064v33.182zm0-34.29h-29.064V294.83h29.064v33.172zm0-34.29h-29.064V260.54h29.064v33.172zm0-34.3h-29.064V226.25h29.064v33.162zm0-34.29h-29.064V191.96h29.064v33.162zm0-34.29h-29.064V157.66h29.064v33.172zm0-34.29h-29.064V123.37h29.064v33.172zm30.045 480.07h-29.064V603.44h29.064v33.172zm0-34.279h-29.064V569.14h29.064v33.193zm0-34.291h-29.064V534.85h29.064v33.192zm0-34.29h-29.064V500.56h29.064v33.192zm0-34.309h-29.064V466.27h29.064v33.173zm0-34.29h-29.064V431.98h29.064v33.173zm0-34.29h-29.064V397.69h29.064v33.173zm0-34.28h-29.064V363.4h29.064v33.183zm0-34.29h-29.064V329.11h29.064v33.183zm0-34.29h-29.064V294.83h29.064v33.173zm0-34.29h-29.064V260.54h29.064v33.173zm0-34.3h-29.064V226.25h29.064v33.163zm0-34.29h-29.064V191.96h29.064v33.163zm0-34.29h-29.064V157.66h29.064v33.173zm0-34.29h-29.064V123.37h29.064v33.173zm30.045 480.07h-29.064V603.44h29.064v33.173zm0-34.28h-29.064V569.14h29.064v33.193zm0-34.29h-29.064V534.85h29.064v33.193zm0-34.29h-29.064V500.56h29.064v33.193zm0-34.31h-29.064V466.27h29.064v33.173zm0-34.29h-29.064V431.98h29.064v33.173zm0-34.29h-29.064V397.69h29.064v33.173zm0-34.28h-29.064V363.4h29.064v33.183zm0-34.29h-29.064V329.11h29.064v33.183zm0-34.29h-29.064V294.83h29.064v33.173zm0-34.29h-29.064V260.54h29.064v33.173zm0-34.3h-29.064V226.25h29.064v33.163zm0-34.29h-29.064V191.96h29.064v33.163zm0-34.29h-29.064V157.66h29.064v33.173zm0-34.29h-29.064V123.37h29.064v33.173zm30.045 480.07h-29.064V603.44h29.064v33.173zm0-34.28h-29.064V569.14h29.064v33.193zm0-34.29h-29.064V534.85h29.064v33.193zm0-34.29h-29.064V500.56h29.064v33.193zm0-34.309h-29.064V466.27h29.064v33.174zm0-34.29h-29.064V431.98h29.064v33.174zm0-34.29h-29.064V397.69h29.064v33.174zm0-34.28h-29.064V363.4h29.064v33.184zm0-34.29h-29.064V329.11h29.064v33.184zm0-34.29h-29.064V294.83h29.064v33.174zm0-34.29h-29.064V260.54h29.064v33.174zm0-34.3h-29.064V226.25h29.064v33.164zm0-34.29h-29.064V191.96h29.064v33.164zm0-34.29h-29.064V157.66h29.064v33.174zm30.044 445.78h-29.063V603.44h29.063v33.174zm0-34.28h-29.063V569.14h29.063v33.194zm0-34.29h-29.063V534.85h29.063v33.194zm0-34.29h-29.063V500.56h29.063v33.194zm0-34.31h-29.063V466.27h29.063v33.174zm0-34.29h-29.063V431.98h29.063v33.174zm0-34.29h-29.063V397.69h29.063v33.174zm0-34.28h-29.063V363.4h29.063v33.184zm0-34.29h-29.063V329.11h29.063v33.184zm0-34.29h-29.063V294.83h29.063v33.174zm0-34.29h-29.063V260.54h29.063v33.174zm0-34.3h-29.063V226.25h29.063v33.164zm0-34.29h-29.063V191.96h29.063v33.164zm0-34.29h-29.063V157.66h29.063v33.174zm30.045 411.5h-29.063V569.14h29.063v33.194zm0-34.29h-29.063V534.85h29.063v33.194zm0-34.29h-29.063V500.56h29.063v33.194zm0-34.31h-29.063V466.27h29.063v33.174zm0-34.29h-29.063V431.98h29.063v33.174zm0-34.29h-29.063V397.69h29.063v33.174zm0-34.28h-29.063V363.4h29.063v33.184zm0-34.29h-29.063V329.11h29.063v33.184zm0-34.29h-29.063V294.83h29.063v33.174zm0-34.29h-29.063V260.54h29.063v33.174zm0-34.299h-29.063V226.25h29.063v33.165zm0-34.29h-29.063V191.96h29.063v33.165zm0-34.29h-29.063V157.66h29.063v33.175zm30.045 411.5h-29.064V569.14h29.064v33.195zm0-34.291h-29.064V534.85h29.064v33.194zm0-34.29h-29.064V500.56h29.064v33.194zm0-34.309h-29.064V466.27h29.064v33.175zm0-34.29h-29.064V431.98h29.064v33.175zm0-34.29h-29.064V397.69h29.064v33.175zm0-34.28h-29.064V363.4h29.064v33.185zm0-34.29h-29.064V329.11h29.064v33.185zm0-34.29h-29.064V294.83h29.064v33.175zm0-34.29h-29.064V260.54h29.064v33.175zm0-34.3h-29.064V226.25h29.064v33.165zm0-34.29h-29.064V191.96h29.064v33.165zm0-34.29h-29.064V157.66h29.064v33.175zm30.045 377.21h-29.064V534.85h29.064v33.195zm0-34.29h-29.064V500.56h29.064v33.195zm0-34.31h-29.064V466.27h29.064v33.175zm0-34.29h-29.064V431.98h29.064v33.175zm0-34.29h-29.064V397.69h29.064v33.175zm0-34.28h-29.064V363.4h29.064v33.185zm0-34.29h-29.064V329.11h29.064v33.185zm0-34.29h-29.064V294.83h29.064v33.175zm0-34.29h-29.064V260.54h29.064v33.175zm0-34.3h-29.064V226.25h29.064v33.165zm0-34.29h-29.064V191.96h29.064v33.165zm0-34.29h-29.064V157.66h29.064v33.175zm30.045 274.32h-29.064V431.98h29.064v33.175zm0-34.29h-29.064V397.69h29.064v33.175zm0-34.28h-29.064V363.4h29.064v33.185zm0-34.29h-29.064V329.11h29.064v33.185zm0-34.29h-29.064V294.83h29.064v33.175zm0-34.29h-29.064V260.54h29.064v33.175zm0-34.299h-29.064V226.25h29.064v33.166zm0-34.29h-29.064V191.96h29.064v33.166zm0-34.29h-29.064V157.66h29.064v33.176zm0-34.29h-29.064V123.37h29.064v33.176zm30.045 274.32h-29.064V397.69h29.064v33.176zm0-34.28h-29.064V363.4h29.064v33.186zm0-34.29h-29.064V329.11h29.064v33.186zm0-34.29h-29.064V294.83h29.064v33.176zm0-34.29h-29.064V260.54h29.064v33.176zm0-34.3h-29.064V226.25h29.064v33.166zm0-34.29h-29.064V191.96h29.064v33.166zm0-34.29h-29.064V157.66h29.064v33.176zm0-34.29h-29.064V123.37h29.064v33.176zm30.054 240.04h-29.073V363.4h29.073v33.186zm0-34.29h-29.073V329.11h29.073v33.186zm0-34.29h-29.073V294.83h29.073v33.176zm0-34.29h-29.073V260.54h29.073v33.176zm0-34.3h-29.073V226.25h29.073v33.166zm0-34.29h-29.073V191.96h29.073v33.166zm0-34.29h-29.073V157.66h29.073v33.176zm0-34.29h-29.073V123.37h29.073v33.176zm31.017 171.46h-30.045V294.83h30.045v33.176zm0-34.29h-30.045V260.54h30.045v33.176zm0-34.3h-30.045V226.25h30.045v33.166zm0-34.29h-30.045V191.96h30.045v33.166zm0-34.29h-30.045V157.66h30.045v33.176zm29.072 68.58h-28.091V226.25h28.091v33.166z"
          fill="#fff"
        />
      </g>
      <g id="Group_17">
        <g
          id="angular-icon-1_1"
          clipPath="url(#clip0)"
          filter="url(#filter0_d)"
        >
          <path
            id="Vector"
            d="M355.649 571.355l18.308-17.836 25.985-2.67 9.639 30.59-14.05 19.066-23.259-1.767-16.623-27.383z"
            fill="#E23237"
          />
          <path
            id="Vector_2"
            d="M399.942 550.849l-25.985 2.67 21.574 46.986 14.058-19.049-9.647-30.607z"
            fill="#B52E31"
          />
          <path
            id="Vector_3"
            d="M376.51 558.989l.279 36.564 5.054-2.425-.401-8.094 12.232-5.616 6.176 5.546 4.909-2.149-28.249-23.826zm4.493 9.693l9.027 7.506-8.663 3.977-.364-11.483z"
            fill="#fff"
          />
        </g>
        <path
          id="Path"
          opacity={0.1}
          d="M843.861 180.89v245.63a3.963 3.963 0 01-3.97 3.96h-348.19v13.77a5.087 5.087 0 01-5.08 5.08h-80.73a5.087 5.087 0 01-5.08-5.08v-58.6a5.087 5.087 0 015.08-5.08h34.32V180.89c.001-5.666 4.594-10.259 10.26-10.26h383.13c5.664.005 10.255 4.596 10.26 10.26z"
          fill="#00D3FF"
        />
        <path
          id="Path_2"
          d="M832.681 169.71v245.63a3.963 3.963 0 01-3.97 3.96h-395.71a3.963 3.963 0 01-3.97-3.96V169.71c.001-5.666 4.594-10.259 10.26-10.26h383.13c5.664.005 10.255 4.596 10.26 10.26h0z"
          fill="#111827"
          stroke="#fff"
          strokeWidth={1.118}
        />
        <g id="Window_Controls" clipPath="url(#clip1)">
          <g id="Close">
            <circle cx={444.667} cy={170.667} r={4.667} fill="#ED6A5E" />
            <circle
              cx={444.667}
              cy={170.667}
              r={4.278}
              stroke="#000"
              strokeOpacity={0.1}
              strokeWidth={0.778}
            />
          </g>
          <g id="Minimize">
            <circle cx={460.222} cy={170.667} r={4.667} fill="#F4BD50" />
            <circle
              cx={460.222}
              cy={170.667}
              r={4.278}
              stroke="#000"
              strokeOpacity={0.1}
              strokeWidth={0.778}
            />
          </g>
          <g id="Zoom">
            <circle cx={475.778} cy={170.667} r={4.667} fill="#61C454" />
            <circle
              cx={475.778}
              cy={170.667}
              r={4.278}
              stroke="#000"
              strokeOpacity={0.1}
              strokeWidth={0.778}
            />
          </g>
        </g>
        <path id="Path_3" d="M429.267 182.626h403.34" stroke="#fff" />
        <path
          id="Shape_2"
          d="M681.371 247.96h-1.92a.762.762 0 01-.7-.51c-.06-.17-.14-.35-.22-.53a.766.766 0 01.14-.85l1.36-1.35a.9.9 0 000-1.27l-2.21-2.21a.9.9 0 00-1.27 0l-1.37 1.37a.75.75 0 01-.82.15c-.19-.08-.4-.17-.58-.24a.727.727 0 01-.47-.69v-1.93a.895.895 0 00-.9-.9h-3.13a.896.896 0 00-.89.9v1.91a.78.78 0 01-.5.71 5.352 5.352 0 00-.56.23.743.743 0 01-.85-.14l-1.36-1.35a.9.9 0 00-1.27 0l-2.21 2.22a.9.9 0 00.01 1.27l1.37 1.36c.214.216.277.54.16.82-.09.19-.17.4-.24.58a.75.75 0 01-.69.48h-1.94a.895.895 0 00-.89.9l.01 3.12a.898.898 0 00.9.9h1.91a.75.75 0 01.71.5c.065.177.138.351.22.52a.778.778 0 01-.14.86l-1.35 1.36a.9.9 0 000 1.27l2.21 2.2a.9.9 0 001.27 0l1.36-1.37a.74.74 0 01.82-.16c.2.09.41.17.59.24a.74.74 0 01.47.69v1.93a.901.901 0 00.9.9h3.13a.893.893 0 00.89-.9v-1.92a.757.757 0 01.5-.7c.18-.07.36-.15.53-.22a.728.728 0 01.85.14l1.36 1.35a.9.9 0 001.27 0l2.21-2.21a.9.9 0 000-1.27l-1.37-1.37a.737.737 0 01-.16-.82c.2-.46.41-1.02.42-1.05h2.45a.9.9 0 00.89-.9v-3.13a.885.885 0 00-.9-.89zm-6.17 3.26a4.426 4.426 0 01-8.219 1.366 4.427 4.427 0 118.219-1.366z"
          fill="#fff"
        />
        <path
          id="Rectangle"
          d="M681.397 202.296h-21.102a2.433 2.433 0 00-2.433 2.433v16.572a2.433 2.433 0 002.433 2.433h21.102a2.434 2.434 0 002.434-2.433v-16.572a2.433 2.433 0 00-2.434-2.433z"
          stroke="#fff"
          strokeWidth={1.118}
        />
        <g id="switch-1">
          <path
            id="Rectangle_2"
            d="M808.454 335.456h-22.843a7.721 7.721 0 000 15.443h22.843a7.721 7.721 0 000-15.443z"
            stroke="#fff"
            strokeWidth={1.118}
          />
          <path
            id="Rectangle_3"
            className="switchToggle1"
            d="M785.832 334.906h-.228a8.27 8.27 0 100 16.542h.228a8.27 8.27 0 008.27-8.271 8.27 8.27 0 00-8.27-8.271z"
            fill="#fff"
          />
        </g>
        <g id="switch-3">
          <path
            id="Rectangle_4"
            d="M808.454 390.204h-22.843a7.721 7.721 0 000 15.442h22.843a7.721 7.721 0 000-15.442z"
            stroke="#fff"
            strokeWidth={1.118}
          />
          <path
            id="Rectangle_5"
            d="M785.824 390.204h-.213a7.721 7.721 0 000 15.442h.213a7.721 7.721 0 000-15.442z"
            fill="#fff"
          />
        </g>
        <g id="switch-2">
          <path
            id="Rectangle_6"
            d="M785.611 377.968h22.843a7.721 7.721 0 007.721-7.721v0a7.721 7.721 0 00-7.721-7.721h-22.843a7.721 7.721 0 00-7.721 7.721v0a7.721 7.721 0 007.721 7.721z"
            stroke="#fff"
            strokeWidth={1.118}
          />
          <path
            id="Rectangle_7"
            className="switchToggle2"
            d="M808.455 362.421h-.215a7.826 7.826 0 000 15.652h.215a7.826 7.826 0 000-15.652z"
            fill="#fff"
          />
        </g>
        <path
          id="Rectangle_8"
          d="M755.614 290.97h-95.973a3.424 3.424 0 100 6.847h95.973a3.424 3.424 0 000-6.847z"
          fill="#E3E8E8"
        />
        <path
          id="Rectangle_9"
          d="M682.617 304.353h-22.976a3.423 3.423 0 100 6.847h22.976a3.424 3.424 0 000-6.847z"
          fill="#E3E8E8"
        />
        <path
          id="Rectangle_10"
          d="M707.558 304.353h-10.81a3.423 3.423 0 100 6.847h10.81a3.424 3.424 0 000-6.847z"
          fill="#E3E8E8"
        />
        <path
          id="Rectangle_11"
          d="M731.586 304.353h-10.81a3.423 3.423 0 100 6.847h10.81a3.424 3.424 0 000-6.847z"
          fill="#E3E8E8"
        />
        <path
          id="Rectangle_12"
          d="M719.126 335.456h-59.684a2.161 2.161 0 100 4.323h59.684a2.162 2.162 0 000-4.323z"
          fill="#E3E8E8"
        />
        <path
          id="Rectangle_13"
          d="M698.698 343.828h-39.642c-.981 0-1.775.795-1.775 1.776v.771c0 .981.794 1.776 1.775 1.776h39.642c.981 0 1.776-.795 1.776-1.776v-.771c0-.981-.795-1.776-1.776-1.776z"
          fill="#E3E8E8"
        />
        <path
          id="Rectangle_14"
          d="M719.126 362.526h-59.684a2.16 2.16 0 100 4.322h59.684a2.161 2.161 0 100-4.322z"
          fill="#E3E8E8"
        />
        <path
          id="Rectangle_15"
          d="M698.698 370.898h-39.642c-.981 0-1.775.795-1.775 1.775v.772c0 .981.794 1.775 1.775 1.775h39.642c.981 0 1.776-.794 1.776-1.775v-.772c0-.98-.795-1.775-1.776-1.775z"
          fill="#E3E8E8"
        />
        <path
          id="Rectangle_16"
          d="M719.126 390.204h-59.684a2.16 2.16 0 100 4.322h59.684a2.161 2.161 0 100-4.322z"
          fill="#E3E8E8"
        />
        <path
          id="Rectangle_17"
          d="M698.698 398.576h-39.642c-.981 0-1.775.795-1.775 1.775v.772c0 .981.794 1.775 1.775 1.775h39.642c.981 0 1.776-.794 1.776-1.775v-.772c0-.98-.795-1.775-1.776-1.775z"
          fill="#E3E8E8"
        />
        <path
          id="Path_4"
          d="M429 183h212v236H432.97a3.965 3.965 0 01-3.97-3.961V183z"
          fill="#111827"
        />
        <g id="Group_2" opacity={0.1} fill="#111827">
          <path
            id="Oval"
            opacity={0.1}
            d="M446.407 208.264a3.124 3.124 0 100-6.249 3.124 3.124 0 000 6.249z"
          />
          <path
            id="Oval_2"
            opacity={0.1}
            d="M446.407 225.692a3.124 3.124 0 100-6.249 3.124 3.124 0 000 6.249z"
          />
          <path
            id="Oval_3"
            opacity={0.1}
            d="M446.407 243.12a3.124 3.124 0 100-6.249 3.124 3.124 0 000 6.249z"
          />
          <path
            id="Oval_4"
            opacity={0.1}
            d="M446.407 260.548a3.124 3.124 0 100-6.249 3.124 3.124 0 000 6.249z"
          />
          <path
            id="Oval_5"
            opacity={0.1}
            d="M446.407 277.976a3.124 3.124 0 100-6.249 3.124 3.124 0 000 6.249z"
          />
          <path
            id="Oval_6"
            opacity={0.1}
            d="M446.407 295.404a3.125 3.125 0 10-.001-6.25 3.125 3.125 0 00.001 6.25z"
          />
          <path
            id="Oval_7"
            opacity={0.1}
            d="M446.407 312.832a3.125 3.125 0 10-.001-6.25 3.125 3.125 0 00.001 6.25z"
          />
          <path
            id="Oval_8"
            opacity={0.1}
            d="M446.407 330.26a3.125 3.125 0 10-.001-6.25 3.125 3.125 0 00.001 6.25z"
          />
          <path
            id="Oval_9"
            opacity={0.1}
            d="M446.407 347.688a3.125 3.125 0 10-.001-6.25 3.125 3.125 0 00.001 6.25z"
          />
          <path
            id="Oval_10"
            opacity={0.1}
            d="M446.407 365.116a3.125 3.125 0 10-.001-6.25 3.125 3.125 0 00.001 6.25z"
          />
          <path
            id="Oval_11"
            opacity={0.1}
            d="M446.407 382.543a3.124 3.124 0 100-6.248 3.124 3.124 0 000 6.248z"
          />
          <path
            id="Oval_12"
            opacity={0.1}
            d="M446.407 399.971a3.124 3.124 0 100-6.249 3.124 3.124 0 000 6.249z"
          />
        </g>
        <path
          id="Path_5"
          className="cog"
          d="M630.265 547.319l-10.151-5.131a70.693 70.693 0 00-9.268-22.393l3.533-10.822a3.89 3.89 0 00-.715-4.483l-9.805-9.804a3.907 3.907 0 00-4.505-.727l-10.8 3.544a70.56 70.56 0 00-22.393-9.268l-5.154-10.151a3.875 3.875 0 00-3.678-2.672h-13.862a3.906 3.906 0 00-3.701 2.672l-5.131 10.151a70.56 70.56 0 00-22.393 9.268l-10.822-3.533a3.854 3.854 0 00-4.483.716l-9.804 9.804a3.907 3.907 0 00-.738 4.494l3.555 10.811a70.716 70.716 0 00-9.268 22.393l-10.162 5.154a3.855 3.855 0 00-2.661 3.678v13.862a3.904 3.904 0 002.661 3.701l10.162 5.132a70.711 70.711 0 009.268 22.392l-3.533 10.822a3.854 3.854 0 00.716 4.483l9.804 9.805a3.908 3.908 0 004.494.737l10.811-3.555a70.536 70.536 0 0022.393 9.268l5.154 10.162a3.853 3.853 0 003.678 2.661h13.862a3.904 3.904 0 003.701-2.661l5.131-10.162a70.536 70.536 0 0022.393-9.268l10.822 3.533a3.89 3.89 0 004.483-.715l9.805-9.805a3.907 3.907 0 00.726-4.505l-3.544-10.8a70.693 70.693 0 009.268-22.393l10.151-5.154a3.874 3.874 0 002.672-3.678V551.02a3.906 3.906 0 00-2.672-3.701z"
          fill="#111827"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          className="cog"
          d="M630.265 547.319l-10.151-5.131a70.693 70.693 0 00-9.268-22.393l3.533-10.822a3.89 3.89 0 00-.715-4.483l-9.805-9.804a3.907 3.907 0 00-4.505-.727l-10.8 3.544a70.56 70.56 0 00-22.393-9.268l-5.154-10.151a3.875 3.875 0 00-3.678-2.672h-13.862a3.906 3.906 0 00-3.701 2.672l-5.131 10.151a70.56 70.56 0 00-22.393 9.268l-10.822-3.533a3.854 3.854 0 00-4.483.716l-9.804 9.804a3.907 3.907 0 00-.738 4.494l3.555 10.811a70.716 70.716 0 00-9.268 22.393l-10.162 5.154a3.855 3.855 0 00-2.661 3.678v13.862a3.904 3.904 0 002.661 3.701l10.162 5.132a70.711 70.711 0 009.268 22.392l-3.533 10.822a3.854 3.854 0 00.716 4.483l9.804 9.805a3.908 3.908 0 004.494.737l10.811-3.555a70.536 70.536 0 0022.393 9.268l5.154 10.162a3.853 3.853 0 003.678 2.661h13.862a3.904 3.904 0 003.701-2.661l5.131-10.162a70.536 70.536 0 0022.393-9.268l10.822 3.533a3.89 3.89 0 004.483-.715l9.805-9.805a3.907 3.907 0 00.726-4.505l-3.544-10.8a70.693 70.693 0 009.268-22.393l10.151-5.154a3.874 3.874 0 002.672-3.678V551.02a3.906 3.906 0 00-2.672-3.701zm0 0l-10.151-5.131a70.693 70.693 0 00-9.268-22.393l3.533-10.822a3.89 3.89 0 00-.715-4.483l-9.805-9.804a3.907 3.907 0 00-4.505-.727l-10.8 3.544a70.56 70.56 0 00-22.393-9.268l-5.154-10.151a3.875 3.875 0 00-3.678-2.672h-13.862a3.906 3.906 0 00-3.701 2.672l-5.131 10.151a70.56 70.56 0 00-22.393 9.268l-10.822-3.533a3.854 3.854 0 00-4.483.716l-9.804 9.804a3.907 3.907 0 00-.738 4.494l3.555 10.811a70.716 70.716 0 00-9.268 22.393l-10.162 5.154a3.855 3.855 0 00-2.661 3.678v13.862a3.904 3.904 0 002.661 3.701l10.162 5.132a70.711 70.711 0 009.268 22.392l-3.533 10.822a3.854 3.854 0 00.716 4.483l9.804 9.805a3.908 3.908 0 004.494.737l10.811-3.555a70.536 70.536 0 0022.393 9.268l5.154 10.162a3.853 3.853 0 003.678 2.661h13.862a3.904 3.904 0 003.701-2.661l5.131-10.162a70.536 70.536 0 0022.393-9.268l10.822 3.533a3.89 3.89 0 004.483-.715l9.805-9.805a3.907 3.907 0 00.726-4.505l-3.544-10.8a70.693 70.693 0 009.268-22.393l10.151-5.154a3.874 3.874 0 002.672-3.678V551.02a3.906 3.906 0 00-2.672-3.701zm-46.104 23.287c-.28.772-.604 1.532-.939 2.281a36.188 36.188 0 01-17.888 17.888 32.16 32.16 0 01-2.292.95 36.2 36.2 0 01-25.288 0 32.16 32.16 0 01-2.292-.95 36.186 36.186 0 01-17.887-17.888 33.01 33.01 0 01-.939-2.281 36.052 36.052 0 010-25.299c.279-.772.592-1.543.939-2.292a36.184 36.184 0 0117.887-17.887 33.01 33.01 0 012.281-.939 36.083 36.083 0 0125.31 0 33.01 33.01 0 012.281.939 36.186 36.186 0 0117.888 17.887c.346.749.659 1.52.939 2.292a36.063 36.063 0 010 25.299z"
          stroke="#fff"
          strokeWidth={1.342}
        />
        <g id="Path_6">
          <path d="M972.646 548.283v-33.912h-408.47v33.912" fill="#111827" />
          <path
            d="M972.646 548.283v-33.912h-408.47v33.912"
            stroke="#fff"
            strokeWidth={1.118}
          />
        </g>
        <g id="Path_7">
          <path d="M972.646 581.821V547.91H535.855v33.911" fill="#111827" />
          <path
            d="M972.646 581.821V547.91H535.855v33.911"
            stroke="#fff"
            strokeWidth={1.118}
          />
        </g>
        <g id="Path_8">
          <path d="M972.646 615.36v-33.911H507.533v33.911" fill="#111827" />
          <path
            d="M972.646 615.36v-33.911H507.533v33.911"
            stroke="#fff"
            strokeWidth={1.118}
          />
        </g>
        <g id="Path_9">
          <mask id="path-53-inside-1" fill="#fff">
            <path d="M973 649v-34H479v34" />
          </mask>
          <path d="M973 649v-34H479v34" fill="#111827" />
          <path
            d="M973 615h1.118v-1.118H973V615zm-494 0v-1.118h-1.118V615H479zm495.118 34v-34h-2.236v34h2.236zM973 613.882H479v2.236h494v-2.236zM477.882 615v34h2.236v-34h-2.236z"
            fill="#fff"
            mask="url(#path-53-inside-1)"
          />
        </g>
        <path
          id="Path_10"
          d="M593.47 507.772h109.088v2.242a3.644 3.644 0 01-3.645 3.644H597.115a3.644 3.644 0 01-3.645-3.644v-2.242z"
          fill="#111827"
          stroke="#fff"
          strokeWidth={1.118}
        />
        <path
          id="Path_11"
          d="M607.516 450.62h80.995a4.86 4.86 0 014.86 4.86v52.242h-90.715V455.48a4.86 4.86 0 014.86-4.86z"
          fill="#111827"
          stroke="#fff"
          strokeWidth={1.118}
        />
        <path
          id="Rectangle_18"
          opacity={0.3}
          d="M685.425 456.694h-74.96c-.618 0-1.118.5-1.118 1.118v42.494c0 .617.5 1.118 1.118 1.118h74.96c.617 0 1.118-.501 1.118-1.118v-42.494c0-.618-.501-1.118-1.118-1.118z"
          fill="#6882BA"
        />
        <path
          id="Rectangle_19"
          d="M644.281 461.614h-28.752c-1.025 0-1.855.83-1.855 1.855v0c0 1.025.83 1.856 1.855 1.856h28.752a1.856 1.856 0 001.856-1.856v0a1.855 1.855 0 00-1.856-1.855z"
          fill="#fff"
          stroke="#fff"
          strokeWidth={0.838}
        />
        <path
          id="Rectangle_20"
          d="M664.484 461.614h-10.598c-1.024 0-1.855.83-1.855 1.855v0c0 1.025.831 1.856 1.855 1.856h10.598a1.856 1.856 0 001.855-1.856v0a1.855 1.855 0 00-1.855-1.855z"
          stroke="#fff"
          strokeWidth={0.838}
        />
        <path
          id="Path_12"
          d="M686.541 475.61h-26.08a1.86 1.86 0 010-3.72h26.08"
          stroke="#fff"
          strokeWidth={0.838}
        />
        <path
          id="Rectangle_21"
          d="M640.767 475.605h9.992a1.855 1.855 0 100-3.71h-9.992a1.855 1.855 0 100 3.71z"
          fill="#fff"
          stroke="#fff"
          strokeWidth={0.838}
        />
        <path
          id="Path_13"
          d="M609.411 471.89h21.75a1.86 1.86 0 010 3.72h-21.75"
          stroke="#fff"
          strokeWidth={0.838}
        />
        <path
          id="Rectangle_22"
          d="M637.898 492.456h-23.737a1.855 1.855 0 000 3.711h23.737a1.856 1.856 0 100-3.711z"
          fill="#fff"
          stroke="#fff"
          strokeWidth={0.838}
        />
        <path
          id="Rectangle_23"
          d="M663.115 492.456h-15.612a1.856 1.856 0 000 3.711h15.612a1.856 1.856 0 100-3.711z"
          stroke="#fff"
          strokeWidth={0.838}
        />
        <path
          id="Rectangle_24"
          d="M619.417 485.886h16.292a1.855 1.855 0 100-3.711h-16.292a1.855 1.855 0 000 3.711z"
          stroke="#fff"
          strokeWidth={0.838}
        />
        <path
          id="Path_14"
          d="M609.411 482.18h1.77a1.855 1.855 0 110 3.71h-1.77"
          stroke="#fff"
          strokeWidth={0.838}
        />
        <path
          id="Rectangle_25"
          d="M648.319 482.175h-3.152a1.856 1.856 0 00-1.855 1.856v0c0 1.025.831 1.855 1.855 1.855h3.152c1.024 0 1.855-.83 1.855-1.855v0a1.856 1.856 0 00-1.855-1.856z"
          stroke="#fff"
          strokeWidth={0.838}
        />
        <path
          id="Rectangle_26"
          d="M675.234 482.175h-19.992a1.856 1.856 0 00-1.856 1.856v0c0 1.025.831 1.855 1.856 1.855h19.992c1.024 0 1.855-.83 1.855-1.855v0a1.856 1.856 0 00-1.855-1.856z"
          stroke="#fff"
          strokeWidth={0.838}
        />
        <path
          id="Rectangle_27"
          d="M477.206 201.54h-6.473a2.69 2.69 0 100 5.38h6.473a2.69 2.69 0 000-5.38z"
          fill="#5DC8DD"
        />
        <path
          id="Rectangle_28"
          d="M534.081 201.54H492.4a2.69 2.69 0 100 5.38h41.681a2.69 2.69 0 000-5.38z"
          fill="#37BA99"
        />
        <path
          id="Rectangle_29"
          d="M563.367 201.54h-15.362a2.69 2.69 0 100 5.38h15.362a2.69 2.69 0 000-5.38z"
          fill="#EFC01A"
        />
        <path
          id="Rectangle_30"
          d="M625.252 216.444h-67.711a2.69 2.69 0 100 5.379h67.711a2.69 2.69 0 100-5.379z"
          fill="#F16D6E"
        />
        <path
          id="Rectangle_31"
          d="M528.986 221.823h14.485a2.69 2.69 0 100-5.379h-14.485a2.69 2.69 0 100 5.379z"
          fill="#37BA99"
        />
        <path
          id="Rectangle_32"
          d="M470.733 221.823h44.329a2.69 2.69 0 000-5.379h-44.329a2.69 2.69 0 100 5.379z"
          fill="#EFC01A"
        />
        <path
          id="Rectangle_33"
          d="M477.206 246.251h-6.473a2.69 2.69 0 000 5.38h6.473a2.69 2.69 0 000-5.38z"
          fill="#37BA99"
        />
        <path
          id="Rectangle_34"
          d="M524.828 246.251h-34.412a2.69 2.69 0 000 5.38h34.412a2.69 2.69 0 000-5.38z"
          fill="#F16D6E"
        />
        <path
          id="Rectangle_35"
          d="M561.384 246.251h-22.632a2.69 2.69 0 000 5.38h22.632a2.69 2.69 0 000-5.38z"
          fill="#37BA99"
        />
        <path
          id="Rectangle_36"
          d="M600.127 261.155h-67.38a2.69 2.69 0 100 5.379h67.38a2.69 2.69 0 100-5.379z"
          fill="#EFC01A"
        />
        <path
          id="Rectangle_37"
          d="M517.085 266.534h4.568a2.69 2.69 0 100-5.379h-4.568a2.69 2.69 0 100 5.379z"
          fill="#37BA99"
        />
        <path
          id="Rectangle_38"
          d="M470.733 266.534h34.411a2.69 2.69 0 100-5.379h-34.411a2.69 2.69 0 100 5.379z"
          fill="#5DC8DD"
        />
        <path
          id="Rectangle_39"
          d="M498.036 236.727h23.617a2.69 2.69 0 000-5.379h-23.617a2.69 2.69 0 100 5.379z"
          fill="#37BA99"
        />
        <path
          id="Rectangle_40"
          d="M470.733 236.727h15.362a2.69 2.69 0 100-5.379h-15.362a2.69 2.69 0 100 5.379z"
          fill="#F16D6E"
        />
        <path
          id="Rectangle_41"
          d="M539.934 231.348h-4.569a2.69 2.69 0 000 5.379h4.569a2.69 2.69 0 000-5.379z"
          fill="#EFC01A"
        />
        <path
          id="Rectangle_42"
          d="M578.951 231.348h-28.982a2.69 2.69 0 000 5.379h28.982a2.69 2.69 0 100-5.379z"
          fill="#5DC8DD"
        />
        <path
          id="Rectangle_43"
          d="M477.206 320.783h-6.473a2.69 2.69 0 100 5.379h6.473a2.69 2.69 0 000-5.379z"
          fill="#EFC01A"
        />
        <path
          id="Rectangle_44"
          d="M524.828 320.783h-34.412a2.69 2.69 0 000 5.379h34.412a2.69 2.69 0 000-5.379z"
          fill="#37BA99"
        />
        <path
          id="Rectangle_45"
          d="M559.4 320.783h-22.632a2.69 2.69 0 000 5.379H559.4a2.69 2.69 0 100-5.379z"
          fill="#5DC8DD"
        />
        <path
          id="Rectangle_46"
          d="M498.036 311.258h23.617a2.69 2.69 0 100-5.379h-23.617a2.69 2.69 0 100 5.379z"
          fill="#EFC01A"
        />
        <path
          id="Rectangle_47"
          d="M470.733 311.258h15.362a2.69 2.69 0 100-5.379h-15.362a2.69 2.69 0 100 5.379z"
          fill="#37BA99"
        />
        <path
          id="Rectangle_48"
          d="M537.95 305.879h-4.568a2.69 2.69 0 100 5.379h4.568a2.69 2.69 0 100-5.379z"
          fill="#37BA99"
        />
        <path
          id="Rectangle_49"
          d="M576.967 305.879h-28.981a2.69 2.69 0 100 5.379h28.981a2.69 2.69 0 100-5.379z"
          fill="#EFC01A"
        />
        <path
          id="Rectangle_50"
          d="M477.206 290.963h-6.473a2.69 2.69 0 100 5.379h6.473a2.69 2.69 0 000-5.379z"
          fill="#EFC01A"
        />
        <path
          id="Rectangle_51"
          d="M569.815 290.963h-79.399a2.69 2.69 0 000 5.379h79.399a2.69 2.69 0 000-5.379z"
          fill="#F16D6E"
        />
        <path
          id="Rectangle_52"
          d="M604.387 290.963h-22.632a2.69 2.69 0 000 5.379h22.632a2.69 2.69 0 100-5.379z"
          fill="#5DC8DD"
        />
        <path
          id="Rectangle_53"
          d="M581.2 276.059h-48.453a2.69 2.69 0 100 5.379H581.2a2.69 2.69 0 100-5.379z"
          fill="#37BA99"
        />
        <path
          id="Rectangle_54"
          d="M498.036 281.438h23.617a2.69 2.69 0 100-5.379h-23.617a2.69 2.69 0 100 5.379z"
          fill="#5DC8DD"
        />
        <path
          id="Rectangle_55"
          d="M470.733 281.438h15.362a2.69 2.69 0 100-5.379h-15.362a2.69 2.69 0 100 5.379z"
          fill="#37BA99"
        />
        <path
          id="Path_15"
          opacity={0.1}
          d="M491.701 385.65v33.65h-58.7a3.967 3.967 0 01-3.97-3.96v-34.77h57.59a5.087 5.087 0 015.08 5.08z"
          fill="#00D3FF"
        />
        <path
          id="Oval_13"
          d="M571.835 522.13a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_14"
          d="M583.239 522.13a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_15"
          d="M594.644 522.13a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_16"
          d="M606.049 522.13a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_17"
          d="M617.453 522.13a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_18"
          d="M628.858 522.13a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_19"
          d="M640.262 522.13a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_20"
          d="M651.667 522.13a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_21"
          d="M663.072 522.13a1.657 1.657 0 000-3.311 1.655 1.655 0 000 3.311z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_22"
          d="M674.477 522.13a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_23"
          d="M685.881 522.13a1.657 1.657 0 000-3.311 1.655 1.655 0 000 3.311z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_24"
          d="M697.286 522.13a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_25"
          d="M708.691 522.13a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_26"
          d="M720.095 522.13a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_27"
          d="M731.5 522.13a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_28"
          d="M742.905 522.13a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_29"
          d="M754.309 522.13a1.657 1.657 0 000-3.311 1.655 1.655 0 000 3.311z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_30"
          d="M765.714 522.13a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_31"
          d="M777.118 522.13a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_32"
          d="M788.523 522.13a1.657 1.657 0 000-3.311 1.655 1.655 0 000 3.311z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_33"
          d="M799.928 522.13a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_34"
          d="M811.332 522.13a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_35"
          d="M571.835 532.982a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_36"
          d="M583.239 532.982a1.655 1.655 0 10.001-3.31 1.655 1.655 0 00-.001 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_37"
          d="M594.644 532.982a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_38"
          d="M606.049 532.982a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_39"
          d="M617.453 532.982a1.655 1.655 0 10.001-3.31 1.655 1.655 0 00-.001 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_40"
          d="M628.858 532.982a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_41"
          d="M640.262 532.982a1.655 1.655 0 10.001-3.31 1.655 1.655 0 00-.001 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_42"
          d="M651.667 532.982a1.655 1.655 0 10.001-3.31 1.655 1.655 0 00-.001 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_43"
          d="M663.072 532.982a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_44"
          d="M674.477 532.982a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_45"
          d="M685.881 532.982a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_46"
          d="M697.286 532.982a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_47"
          d="M708.691 532.982a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_48"
          d="M720.095 532.982a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_49"
          d="M731.5 532.982a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_50"
          d="M742.905 532.982a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_51"
          d="M754.309 532.982a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_52"
          d="M765.714 532.982a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_53"
          d="M777.118 532.982a1.655 1.655 0 10.001-3.31 1.655 1.655 0 00-.001 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_54"
          d="M788.523 532.982a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_55"
          d="M799.928 532.982a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_56"
          d="M811.332 532.982a1.655 1.655 0 10.001-3.31 1.655 1.655 0 00-.001 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_57"
          d="M571.835 543.835a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_58"
          d="M583.239 543.835a1.655 1.655 0 10.001-3.31 1.655 1.655 0 00-.001 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_59"
          d="M594.644 543.835a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_60"
          d="M606.049 543.835a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_61"
          d="M617.453 543.835a1.655 1.655 0 10.001-3.31 1.655 1.655 0 00-.001 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_62"
          d="M628.858 543.835a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_63"
          d="M640.262 543.835a1.655 1.655 0 10.001-3.31 1.655 1.655 0 00-.001 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_64"
          d="M651.667 543.835a1.655 1.655 0 10.001-3.31 1.655 1.655 0 00-.001 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_65"
          d="M663.072 543.835a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_66"
          d="M674.477 543.835a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_67"
          d="M685.881 543.835a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_68"
          d="M697.286 543.835a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_69"
          d="M708.691 543.835a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_70"
          d="M720.095 543.835a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_71"
          d="M731.5 543.835a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_72"
          d="M742.905 543.835a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_73"
          d="M754.309 543.835a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_74"
          d="M765.714 543.835a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_75"
          d="M777.118 543.835a1.655 1.655 0 10.001-3.31 1.655 1.655 0 00-.001 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_76"
          d="M788.523 543.835a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_77"
          d="M799.928 543.835a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_78"
          d="M811.332 543.835a1.655 1.655 0 10.001-3.31 1.655 1.655 0 00-.001 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_79"
          d="M823.105 522.13a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_80"
          d="M834.509 522.13a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_81"
          d="M845.914 522.13a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_82"
          d="M857.319 522.13a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_83"
          d="M868.723 522.13a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_84"
          d="M880.128 522.13a1.657 1.657 0 000-3.311 1.655 1.655 0 000 3.311z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_85"
          d="M891.533 522.13a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_86"
          d="M902.938 522.13a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_87"
          d="M823.105 532.982a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_88"
          d="M834.509 532.982a1.655 1.655 0 10.001-3.31 1.655 1.655 0 00-.001 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_89"
          d="M845.914 532.982a1.655 1.655 0 10.001-3.31 1.655 1.655 0 00-.001 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_90"
          d="M857.319 532.982a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_91"
          d="M868.723 532.982a1.655 1.655 0 10.001-3.31 1.655 1.655 0 00-.001 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_92"
          d="M880.128 532.982a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_93"
          d="M891.533 532.982a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_94"
          d="M902.938 532.982a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_95"
          d="M823.105 543.835a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_96"
          d="M834.509 543.835a1.655 1.655 0 10.001-3.31 1.655 1.655 0 00-.001 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_97"
          d="M845.914 543.835a1.655 1.655 0 10.001-3.31 1.655 1.655 0 00-.001 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_98"
          d="M857.319 543.835a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_99"
          d="M868.723 543.835a1.655 1.655 0 10.001-3.31 1.655 1.655 0 00-.001 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_100"
          d="M880.128 543.835a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_101"
          d="M891.533 543.835a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_102"
          d="M902.938 543.835a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_103"
          d="M515.789 589.064a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_104"
          d="M527.194 589.064a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_105"
          d="M538.598 589.064a1.657 1.657 0 000-3.311 1.655 1.655 0 000 3.311z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_106"
          d="M550.003 589.064a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_107"
          d="M561.407 589.064a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_108"
          d="M572.812 589.064a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_109"
          d="M584.217 589.064a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_110"
          d="M595.621 589.064a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_111"
          d="M607.026 589.064a1.657 1.657 0 000-3.311 1.655 1.655 0 000 3.311z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_112"
          d="M618.431 589.064a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_113"
          d="M629.835 589.064a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_114"
          d="M641.24 589.064a1.657 1.657 0 10-.001-3.313 1.657 1.657 0 00.001 3.313z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_115"
          d="M652.645 589.064a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_116"
          d="M664.049 589.064a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_117"
          d="M675.454 589.064a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_118"
          d="M686.859 589.064a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_119"
          d="M698.263 589.064a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_120"
          d="M709.668 589.064a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_121"
          d="M721.073 589.064a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_122"
          d="M732.477 589.064a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_123"
          d="M743.882 589.064a1.657 1.657 0 000-3.311 1.655 1.655 0 000 3.311z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_124"
          d="M755.287 589.064a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_125"
          d="M515.789 599.917a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_126"
          d="M527.194 599.917a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_127"
          d="M538.598 599.917a1.657 1.657 0 10-.001-3.313 1.657 1.657 0 00.001 3.313z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_128"
          d="M550.003 599.917a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_129"
          d="M561.407 599.917a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_130"
          d="M572.812 599.917a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_131"
          d="M584.217 599.917a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_132"
          d="M595.621 599.917a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_133"
          d="M607.026 599.917a1.657 1.657 0 10-.001-3.313 1.657 1.657 0 00.001 3.313z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_134"
          d="M618.431 599.917a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_135"
          d="M629.835 599.917a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_136"
          d="M641.24 599.917a1.657 1.657 0 10-.001-3.313 1.657 1.657 0 00.001 3.313z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_137"
          d="M652.645 599.917a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_138"
          d="M664.049 599.917a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_139"
          d="M675.454 599.917a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_140"
          d="M686.859 599.917a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_141"
          d="M698.263 599.917a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_142"
          d="M709.668 599.917a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_143"
          d="M721.073 599.917a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_144"
          d="M732.477 599.917a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_145"
          d="M743.882 599.917a1.657 1.657 0 10-.001-3.313 1.657 1.657 0 00.001 3.313z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_146"
          d="M755.287 599.917a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_147"
          d="M515.789 610.769a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_148"
          d="M527.194 610.769a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_149"
          d="M538.598 610.769a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_150"
          d="M550.003 610.769a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_151"
          d="M561.407 610.769a1.655 1.655 0 10.001-3.31 1.655 1.655 0 00-.001 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_152"
          d="M572.812 610.769a1.655 1.655 0 10.001-3.31 1.655 1.655 0 00-.001 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_153"
          d="M584.217 610.769a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_154"
          d="M595.621 610.769a1.655 1.655 0 10.001-3.31 1.655 1.655 0 00-.001 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_155"
          d="M607.026 610.769a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_156"
          d="M618.431 610.769a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_157"
          d="M629.835 610.769a1.655 1.655 0 10.001-3.31 1.655 1.655 0 00-.001 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_158"
          d="M641.24 610.769a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_159"
          d="M652.645 610.769a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_160"
          d="M664.049 610.769a1.655 1.655 0 10.001-3.31 1.655 1.655 0 00-.001 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_161"
          d="M675.454 610.769a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_162"
          d="M686.859 610.769a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_163"
          d="M698.263 610.769a1.655 1.655 0 10.001-3.31 1.655 1.655 0 00-.001 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_164"
          d="M709.668 610.769a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_165"
          d="M721.073 610.769a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_166"
          d="M732.477 610.769a1.655 1.655 0 10.001-3.31 1.655 1.655 0 00-.001 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_167"
          d="M743.882 610.769a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_168"
          d="M755.287 610.769a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_169"
          d="M767.059 589.064a1.657 1.657 0 000-3.311 1.655 1.655 0 000 3.311z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_170"
          d="M778.464 589.064a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_171"
          d="M789.868 589.064a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_172"
          d="M801.273 589.064a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_173"
          d="M812.678 589.064a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_174"
          d="M824.082 589.064a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_175"
          d="M835.487 589.064a1.657 1.657 0 000-3.311 1.655 1.655 0 000 3.311z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_176"
          d="M846.892 589.064a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_177"
          d="M767.059 599.917a1.657 1.657 0 10-.001-3.313 1.657 1.657 0 00.001 3.313z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_178"
          d="M778.464 599.917a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_179"
          d="M789.868 599.917a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_180"
          d="M801.273 599.917a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_181"
          d="M812.678 599.917a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_182"
          d="M824.082 599.917a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_183"
          d="M835.487 599.917a1.657 1.657 0 10-.001-3.313 1.657 1.657 0 00.001 3.313z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_184"
          d="M846.892 599.917a1.656 1.656 0 10-.002-3.312 1.656 1.656 0 00.002 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_185"
          d="M767.059 610.769a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_186"
          d="M778.464 610.769a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_187"
          d="M789.868 610.769a1.655 1.655 0 10.001-3.31 1.655 1.655 0 00-.001 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_188"
          d="M801.273 610.769a1.655 1.655 0 10.001-3.31 1.655 1.655 0 00-.001 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_189"
          d="M812.678 610.769a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_190"
          d="M824.082 610.769a1.655 1.655 0 10.001-3.31 1.655 1.655 0 00-.001 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_191"
          d="M835.487 610.769a1.656 1.656 0 100-3.312 1.656 1.656 0 000 3.312z"
          fill="#BFF4FF"
        />
        <path
          id="Oval_192"
          d="M846.892 610.769a1.655 1.655 0 100-3.31 1.655 1.655 0 000 3.31z"
          fill="#BFF4FF"
        />
        <path
          id="Path_16"
          d="M913.913 547.851h.5v-33.539h58.292v134.087H829.447v-33.47h28.322V581.39h28.322v-33.539h27.822z"
          stroke="#fff"
        />
        <path
          id="Rectangle_56"
          opacity={0.3}
          d="M408.805 499.571l-18.053-7.147-7.146 18.053 18.052 7.147 7.147-18.053z"
          stroke="#B5B5B5"
          strokeWidth={1.677}
        />
        <path
          id="Rectangle_57"
          opacity={0.3}
          d="M408.23 547.302l-66.734 12.678 12.679 66.734 66.734-12.679-12.679-66.733z"
          stroke="#B5B5B5"
          strokeWidth={1.677}
        />
        <path
          id="Path_17"
          d="M369.257 590.8l-25.443 14.81-18.185-31.24 43.628 16.43z"
          fill="#111827"
          stroke="#fff"
          strokeWidth={1.118}
        />
        <path
          id="Path_18"
          d="M399.729 590.476l19.923 7.096"
          stroke="#231F20"
          strokeWidth={1.118}
        />
        <path
          id="Rectangle_58"
          d="M400.173 590.474H327.07v58.425h73.103v-58.425z"
          fill="#111827"
          stroke="#fff"
          strokeWidth={1.118}
        />
        <path
          id="Rectangle_59"
          d="M426.636 590.474h-26.462v58.425h26.462v-58.425z"
          fill="#111827"
          stroke="#fff"
          strokeWidth={1.118}
        />
        <path
          id="Rectangle_60"
          d="M367.932 590.476h-13.091v29.745h13.091v-29.745z"
          stroke="#fff"
          strokeWidth={1.118}
        />
        <path
          id="Path_19"
          d="M400.174 590.474v6.708l-15.652 16.937H327.07v-16.937l73.104-6.708z"
          fill="#fff"
        />
        <path
          id="Path_20"
          d="M384.525 607.417h-73.108l15.651-16.941h73.108l-15.651 16.941z"
          fill="#111827"
          stroke="#fff"
          strokeWidth={1.118}
        />
        <path
          id="Path_21"
          d="M426.636 597.383v16.736h-10.688l-15.651-16.937.246-6.216 25.903 6.216.19.201z"
          fill="#fff"
        />
        <path
          id="Path_22"
          d="M415.947 607.417H442.1l-15.652-16.941h-26.153l15.652 16.941z"
          fill="#111827"
          stroke="#fff"
          strokeWidth={1.118}
        />
        <path
          id="Path_23"
          opacity={0.3}
          d="M306 487.326l-10.44-25.03 30.734-12.819L306 487.326z"
          fill="#BFF4FF"
        />
        <path
          d="M315.588 478.547a6.272 6.272 0 100-12.543 6.272 6.272 0 000 12.543z"
          fill="#fff"
          id="Oval_193"
          opacity={0.3}
        />
        <path
          id="Rectangle_61"
          d="M240.014 265.227h138.791a9.014 9.014 0 019.014 9.014v0a9.015 9.015 0 01-9.014 9.015H240.014a9.015 9.015 0 01-9.014-9.015v0a9.014 9.014 0 019.014-9.014z"
          stroke="#fff"
        />
        <path
          id="Rectangle_62"
          d="M240.263 265.227h-.249a9.015 9.015 0 000 18.029h.249a9.015 9.015 0 000-18.029z"
          fill="#fff"
        />
        <path
          id="Path_24"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M296.076 296.829h82.729a9.015 9.015 0 010 18.029h-82.729a9.014 9.014 0 01-9.014-9.014v-.001a9.014 9.014 0 019.014-9.014z"
          stroke="#fff"
          strokeDasharray="5.84 5.84"
        />
        <path
          id="Rectangle_63"
          d="M329.199 314.858h36.265a9.015 9.015 0 000-18.029h-36.265a9.014 9.014 0 00-9.014 9.014 9.014 9.014 0 009.014 9.015z"
          fill="#fff"
        />
        <g id="javascript_1" clipPath="url(#clip2)" filter="url(#filter1_d)">
          <path id="Vector_4" d="M416 403.007h34v34h-34v-34z" fill="#F7DF1E" />
          <path
            id="Vector_5"
            d="M424.94 431.42l2.602-1.575c.502.89.958 1.643 2.054 1.643 1.049 0 1.712-.41 1.712-2.008v-10.864h3.195v10.909c0 3.31-1.94 4.816-4.77 4.816-2.556 0-4.04-1.324-4.793-2.921zm11.298-.343l2.602-1.506c.685 1.119 1.575 1.94 3.149 1.94 1.324 0 2.168-.662 2.168-1.575 0-1.095-.867-1.483-2.328-2.122l-.798-.343c-2.305-.981-3.834-2.213-3.834-4.815 0-2.396 1.825-4.222 4.678-4.222 2.032 0 3.492.707 4.542 2.556l-2.488 1.598c-.548-.982-1.141-1.37-2.054-1.37-.936 0-1.529.594-1.529 1.37 0 .958.593 1.346 1.963 1.94l.798.342c2.716 1.164 4.246 2.351 4.246 5.021 0 2.876-2.26 4.45-5.295 4.45-2.967 0-4.884-1.415-5.82-3.263"
            fill="#111827"
          />
        </g>
        <g id="gsap-greensock_1" clipPath="url(#clip3)">
          <path
            id="Vector_6"
            d="M344.688 237.014c-1.418.67-5.173 3.684-5.896 4.577-.751.892-.974-.503-.195-2.819.612-1.869 2.169-4.409 4.784-6.585 1.529-1.256 4.895-3.07 6.953-4.13.417-.223 5.813-2.511 10.625-3.655.417-.112-.501.697-.64 1.144-.723 2.12-15.158 11.217-15.158 11.217l-.473.251zm20.332 25.588c.25 1.507.028 1.619-1.53 1.814-1.557.196-2.698-.391-3.115-.781-.417-.391-.501-1.256-.083-2.037.25-.502.5-.67.639-1.284.139-.586.251-.725.362-.948.111-.196.139-.391.167-1.758.028-1.368 0-3.935.139-5.023.139-1.116 4.951.502 4.951.502s-1.141 2.846-1.446 3.544c-.307.698-.279 2.037-.279 2.316 0 .279-.111.837-.194.865-.084.028.278.753.111 1.172-.112.391.25 1.395.278 1.618zm1.836-42.665c-.167-1.061 0-3.154.222-3.488.695-.949 4.367-1.061 5.146.056.333.502.306 1.674.25 2.427-.056.754-.25 2.372-.278 2.902-.028.391-4.061 1.005-4.951-.056-.25-.278-.389-1.841-.389-1.841zm8.177 39.959c1.696 1.228 3.004 1.451 3.866 1.897.862.447.64 1.312-.807 1.563-1.168.223-3.004-.223-4.227-.223-1.224 0-3.95.139-4.673-.363-.834-.586-.473-1.674-.473-1.674.223-.614.779-1.982.612-3.098-.167-1.116-.39-1.73-.807-2.762-.417-1.033-.723-3.572-.333-3.712.389-.139.278 0 .778.112.501.112 1.057.279 2.142.279s2.281-.167 2.698-.251c.417-.084.751-.168.612.698-.139.865-.556 2.483-.584 3.739-.028 1.255-.028 2.706.055 2.958.084.251.696.53 1.141.837z"
            fill="#010101"
          />
          <path
            id="Vector_7"
            d="M369.081 222.727c-3.06 2.651-8.984 3.377-17.773 6.781-2.253.865-8.261 3.46-9.707 6.167 4.867-2.818 6.675 1.06 7.064 5.051.362 3.739 2.226 5.692 7.01 5.58 4.923-.111 6.425 2.763 7.787 6.139 2.643-12.919 6.87-15.431 9.596-17.635 5.785-4.716-1.335-13.032-3.977-12.083z"
            fill="#8AC640"
          />
          <path
            id="Vector_8"
            d="M369.081 222.727c-7.343 2.567-14.603 3.209-23.141 8.483-2.031 1.256-6.314 4.102-7.148 9.544 3.115-3.461 10.318-7.814 19.135-10.576 4.451-1.395 7.705-2.316 11.654-3.851-.278-1.786-.278-2.484-.5-3.6z"
            fill="#8AC640"
          />
          <path
            id="Vector_9"
            d="M378.454 238.019s-.529 1.814-1.585 2.4c0 0-.779.279-2.337-.586-.445-.251-.779-1.116-.751-1.396.028-.669.445-.976.445-.976s.445-.754.974-.726c.528.028 1.418.112 1.696-.139.251-.279 1.614.502 1.558 1.423zm-11.348-17.552s-.111 1.423-.306 2.316c-.028.168-.862.251-1.474.502 1.168 3.349 8.205 3.321 9.123 1.675a12.063 12.063 0 00-1.752-.949c-.418-.168-.39-.14-.418-.921-.027-.781-.083-2.232-.139-2.623-.055-.391-4.367-.391-5.034 0z"
            fill="#010101"
          />
          <path
            id="Vector_10"
            d="M367.384 220.467s0 .809-.083 1.591a6.6 6.6 0 01-.112.865c-.027.167.946.837 1.224 2.316 1.335 2.985 4.423 1.506 5.702.083a10.754 10.754 0 00-2.002-1.06c-.418-.168-.223-.53-.251-1.312a32.07 32.07 0 00-.194-2.344c-.056-.418-3.616-.53-4.284-.139z"
            fill="#F0EFEF"
          />
          <g id="Group_3" fill="#010101">
            <path
              id="Vector_11"
              d="M367.106 220.467s-.028.502-.111 1.088c.361.363.834.865 1.196 1.172.25.224.862.196 1.418.196.501 0 .946.055 1.141-.056.445-.223 1.084-.781 1.446-1.2a25.629 25.629 0 00-.083-1.2c-.028-.391-4.34-.391-5.007 0z"
            />
            <path
              id="Vector_12"
              d="M369.637 222.588c-.334 0-.723-.028-1.029-.084-.139-.028-.278-.112-.39-.167-.194-.14-.389-.307-.611-.475-.446-.335-.473-.53-.473-.614.194-1.758-.056-3.237-.056-3.237s-.195-.753.862-.948c1.057-.196 1.697-.224 1.697-.224s.667 0 1.697.224c1.056.195.862.948.862.948s-.251 1.479-.056 3.237c0 .084-.028.279-.473.614-.389.279-.695.586-1.001.642a6.125 6.125 0 01-1.029.084z"
            />
            <path
              id="Vector_13"
              d="M369.637 216.114c-1.836 0-2.197.502-2.726 1.06-.111.14-.028.977.167 2.763h.25s-.167-.503-.139-1.089c.028-.585.139-.558.056-.697-.111-.168-.334-.447.167-.726.501-.279 1.279.224 2.225.251.946-.027 1.752-.53 2.253-.251.5.279.278.558.167.726-.111.167.028.111.055.697.028.586-.139 1.089-.139 1.089h.251c.166-1.786.278-2.567.194-2.707-.473-.614-.945-1.088-2.781-1.116zm8.817 21.988s-.529 1.703-1.558 2.289c-.222-.112-.194-.279-.389-.531-.056-.083-.251-.139-.334-.223-.083-.084-.055-.223-.195-.335-.111-.111-.194-.028-.306-.111-.111-.112-.139-.251-.222-.335-.056-.056-.278-.084-.334-.14-.139-.139-1.362-.39-1.307-.669.111-.419.334-.726.334-.726s.528-.781 1.057-.753c.528.028 1.029.139 1.307-.112.306-.279 2.03.753 1.947 1.646z"
            />
            <path
              id="Vector_14"
              d="M374.838 225.769s1.752-.419 2.948.725c1.196 1.172 1.113 2.623.751 3.516.306.363.863 1.367.445 2.567 1.836 1.563 1.03 3.963-.611 5.553 0 0-.39-1.451-1.947-1.534.055-.558-1.447-1.005-.751-2.456-1.057-.251-1.029-.977-1.196-1.869-.139-.894.361-6.502.361-6.502z"
            />
          </g>
          <path
            id="Vector_15"
            d="M374.198 226.55s2.031-1.032 3.227.14c1.196 1.172.862 2.455.5 3.348.306.363 1.03 1.395.584 2.623-.083.279-.695.279-1.14 1.005 1.112-.642 1.808-.475 2.058.334.39 1.256-.473 2.763-1.224 3.6 0-.028-.027-.056-.027-.084-.112.419-.251 1.228-1.085 2.121-.417.447-.751.391-1.224.279-.556-.139-.751-.391-1.53-.809-.445-.251-.194-.558-.194-.809 0-.056.055-.14.139-.251.055-.14.222-.363.473-.614 0 0 .361-.503.89-.475.528.028 1.084-.083 1.224-.223 0-.977-1.113-1.005-.724-2.679.028-.083.167-.223.612-.279-.667-.139-.973-.167-1.446-.614a2.062 2.062 0 01-.668-1.199c-.166-.865-.445-5.414-.445-5.414z"
            fill="#F0EFEF"
          />
          <path
            id="Vector_16"
            d="M368.33 224.792a5.036 5.036 0 00-2.67-1.786c-.473-.139-.779.251-1.252.53-.139-.083-.751-.362-1.085-.167-.333.195-.556.391-.89.53-.167-.084-.612-.084-.973.056-.362.112-.918.363-1.447 1.088-.333 1.2 5.897.307 5.897.307l2.42-.558z"
            fill="#010101"
          />
          <path
            id="Vector_17"
            d="M368.385 224.792c-.89-.307-.751-1.339-2.725-1.507-.39-.028-.64.279-.918.475.139.139.278.362.361.586-.25-.279-.695-.642-1.14-.726-.417-.084-.696.223-1.141.447.084.083.167.223.278.39-.389-.251-.667-.334-1.195-.139a3.067 3.067 0 00-1.586 1.172c-.334 1.2 5.619-.14 5.619-.14l2.447-.558z"
            fill="#8AC640"
          />
          <path
            id="Vector_18"
            d="M373.614 225.239s0-.307-.028-.586c0-.056-.222-.196-.222-.251l-.056-.056s.445-.251.779-.112c.362.112.556.586.556.586.64-.223.696.028 1.002.363.667-.14.751.111 1.168.726 0 0-.501-.084-1.474.083-.946.14-1.725-.781-1.725-.753z"
            fill="#010101"
          />
          <path
            id="Vector_19"
            d="M373.503 225.099s.167-.139.111-.167c.306-.168.723-.363.918.167.64-.223.723.084 1.029.419.779-.363.835.083.89.279-.25 0-.612.028-1.112.083-.946.14-1.864-.809-1.836-.781z"
            fill="#8AC640"
          />
          <path
            id="Vector_20"
            d="M364.046 224.401s1.586.558 2.921.475c1.335-.112 3.616-.223 4.839.502 0 0 1.252-.446 2.42-.139 1.169.306 3.31 2.316 2.671 4.436-.056.14-.418.363-.835.503 0 0 .223.948-.167 1.73-.389.753-1.251 2.204-1.279 4.213-.028.335-.084 1.033-.139 1.367-2.17-.083-5.507-.893-8.789-.837.027-.362.055-.586.083-.948h.083c-.167-.921-.222-1.396-.389-2.093-1.057-.67-2.17-1.451-3.115-2.93-.918-1.479 1.696-6.279 1.696-6.279zm10.737 15.069s1.724 6.195-.306 8.79c0 0 .306 1.2-.39 2.483-.111.558-.25 1.061-.333 1.618-.362 2.317-.974 3.293-1.141 7.004l-1.669-.027s-.195-2.679-.779-4.102c-.333-.809-1.641-1.898-1.585-2.986.056-.837.223-1.535 1.641-2.651.111-1.618-1.502-3.153-1.251-9.181l5.813-.948z"
            fill="#010101"
          />
          <path
            id="Vector_21"
            d="M374.282 239.219c.445 2.846 1.474 7.059-.39 9.124.11.524.12 1.064.028 1.591a6.476 6.476 0 01-.306 1.088c-.278.67-.389 1.646-.473 2.232-.361 2.316-.361 2.428-.528 6.139l-1.669-.028s-.195-2.679-.779-4.101c-.333-.81-1.029-1.507-1.084-2.596-.056-.837.528-2.511 1.919-2.455-.084-3.377-1.641-2.707-2.058-9.739l5.34-1.255zm-10.236-14.818s.612.196 1.28.252c.667.055 1.391 0 2.03-.028 1.335-.112 3.227-.251 4.478.474 0 0 .696-.223 1.447-.167.333.027.667.307 1.057.418 1.223.307 2.391 2.344 1.863 4.186-.056.139-.445 0-.89.139.083.391.139 1.284-.306 2.233-.473.949-1.085 2.176-.974 4.52-2.92-.139-4.227-.334-7.12-.474-.25-1.033-.417-2.065-.445-2.595.389-.196.612-.363.918-.698-.834.14-1.168.084-1.669-.195-.501-.279-1.391-1.172-1.836-1.758-.055-.056-.361.865-1.056.893-.251-.363.806-1.395.611-1.786-.695-1.423.612-5.414.612-5.414z"
            fill="#F0EFEF"
          />
          <path
            id="Vector_22"
            d="M374.504 236.903s.056 1.004.056 1.255c0 .279.222 1.116.25 1.507-.306.53-1.641 1.73-4.061 2.177-2.392.502-5.562-3.265-5.562-3.265.083-.363.361-1.423.556-1.981a.891.891 0 00.083-.251c.251-.363 8.678.558 8.678.558z"
            fill="#010101"
          />
          <path
            id="Vector_23"
            d="M373.893 236.986c0 .698.111 1.2.194 1.647.139.809.362 1.339.362 1.869 0 1.619-2.114 1.34-3.894 1.396-2.392.502-4.423-3.265-4.423-3.265.167-.642.278-1.367.529-1.981.027-.335.083-.754.111-.949 3.393 0 5.785.195 7.176.335.056.307 0 .837-.055.948z"
            fill="#F0EFEF"
          />
          <path
            id="Vector_24"
            d="M371.222 240.586s-1.474-3.293-5.896-2.316c-1.057 2.986-2.476 6.418-1.558 10.129-.918 1.256-1.975 1.954-1.975 4.27s.112 2.706.112 2.706l3.254.168s1.057-1.367 1.474-2.846a6.094 6.094 0 00.139-2.037c.111-.168.584-.558.64-1.312 0 0 1.585-.837 2.503-2.874.862-1.842.64-3.432 1.307-5.888z"
            fill="#010101"
          />
          <path
            id="Vector_25"
            d="M371.222 240.586c-.083-.307-1.196-3.321-5.312-2.428-2.42 6.474-1.53 9.153-1.168 10.325-1.641 2.093-2.392 2.539-2.058 6.78h2.169c1.001-1.59 1.224-2.176 1.279-4.269 0-.084-.305.168-.528.447.167-.865.64-1.033 1.001-1.563.167-.223.306-.558.306-1.005 1.947-1.311 2.67-2.957 3.088-4.66.333-1.171.723-3.097 1.223-3.627z"
            fill="#F0EFEF"
          />
          <g id="Group_4" fill="#010101">
            <path
              id="Vector_26"
              d="M364.352 236.093s.751.028 1.419.251c.64.224.64.363.89.642.25.28.862.698.751 1.116-.056.224-.195.279-.389.475-.084.084-.696.753-.835.837-.083.056-.195.139-.278.195l-.417.279c-.278.14-.473.224-.779.196 0 0-.695-.028-1.14-.503 0 0-.056-.223.055-.334 0 0-.584-.503-.751-.838-.167-.334-.167-.809-.055-1.06.055-.251 1.14-.949 1.529-1.256zm.696 27.151l-.084.698s-.25.307-2.113.279c-1.892-.028-2.392-.614-2.559-.921l-.111-.725s.361-.531.445-.531c.611.056 2.698.893 4.144 1.116.139 0 .166.056.278.084zm4.033-1.423c0 .307-.028.307-.028.614.334.251 1.168.391 2.753.363 2.309-.056 4.451.697 7.065.251l.028-.503-.25-.027-9.262-.754-.306.056z"
            />
            <path
              id="Vector_27"
              d="M371.111 262.798h.695c1.502-.056 2.921.279 4.451.363.806-.028 1.808-.224 1.724-.81l-7.899-.669c-.473.53-.111.976 1.029 1.116zm-9.067-11.748c.25.167 1.947 1.172 4.7 1.032-.055.531-.028 1.563-1.251 3.377-.612.893-1.141 2.456-1.252 4.437.028.446.278.837-.056 1.423.112.363.557 1.088.779 1.535.223.446.334.948-1.14.976-1.502.028-3.922-.139-3.588-1.311.167-.614.64-1.256.695-1.507.056-.251.056-1.005.529-1.507.417-1.395.278-2.735.195-3.99-.14-1.312-.167-3.405.389-4.465zm2.587-22.742c1.974-2.651.305-4.771-2.865-4.13-1.28.251-2.559 1.144-2.643 2.763-.417.055-1.362.111-1.835 1.841-.362 1.34-.556 1.591-1.196 2.261-.417.474.028 1.451.333 2.148 1.03 2.4 4.2 2.623 6.342 4.437.723-.195 1.474-1.004 1.697-1.535-1.808-2.148-1.419-2.985-2.142-4.102.779-.279 2.559-1.367 2.309-3.683z"
            />
          </g>
          <path
            id="Vector_28"
            d="M364.241 228.141c.111-.168.306-.531.39-.67.027-.028.333.502.361.474.751-1.228.946-3.013.083-3.181a4.912 4.912 0 01-.862-.223c-.556-.196-1.057-.196-1.947-.028-1.224.223-2.447 1.116-2.447 2.4 0 .083.862.335 1.112 1.367-.417-.586-1.14-1.228-2.002-.67-.918.586-.445 1.926-1.669 3.321-.418.474-.362 1.032.083 2.148.723 1.759 4.144 2.707 6.008 4.381.445-.195.751-.641.973-.976-1.251-1.312-1.752-2.54-2.113-3.432-.445-1.033-.946-1.619-1.92-2.4.501.195.891.39 1.113.558.25.167.612.195.946.083 1.196-.418 1.836-2.092 1.891-3.152z"
            fill="#F0EFEF"
          />
          <path
            id="Vector_29"
            d="M376.34 228.587c-.083 1.061-.862.53-1.279.335-.835-.363-1.669-.614-2.643-.614-.973 0-2.225.084-3.309.363-1.502.418-1.948.391-2.615.056-.667-.363-1.836-1.256-1.836-1.256s-.027.279.251.642c.361.446 1.168 1.004 2.253 1.367.528.168.945.056 1.418-.056 2.476-.614 5.09-.725 7.287.614.112.056.501-.112.668-.363.222-.362-.195-1.088-.195-1.088z"
            fill="#010101"
          />
          <path
            id="Vector_30"
            d="M363.685 239.219c.222.139.501.223.806.474 0 0-.25 0-.361-.111a4.009 4.009 0 01-.445-.363z"
            fill="#0A1825"
          />
          <path
            id="Vector_31"
            d="M371.723 217.091c-.083-.252-.695-.698-2.114-.698-1.53 0-1.975.474-2.002.725 0 .084-.112.977-.14 1.34 0 0 0 .446.028 1.116.028.446.139.697.195 1.284.056.613.223 1.004.528 1.506.14.084.251.168.39.196.556.111 1.53.139 2.058 0 .306-.084.695-.614.779-1.089.111-.586.222-1.004.25-1.367.056-.362.084-1.172.111-1.395.084-.614-.055-1.563-.083-1.618z"
            fill="#F0EFEF"
          />
          <path
            id="Vector_32"
            d="M368.803 251.58s1.474.642 5.117.084c0 0-1.029 5.19-.556 7.785 0 0 .473.67 3.978 1.953 0 0 1.557.391 1.501 1.172 0 0 .056.168-1.835.112-1.891-.056-3.672-.391-4.923-.391-1.252 0-2.587.056-2.809-.307-.251-.334.055-1.2.417-1.702.389-.53.278-.921.25-1.869-.084-2.484-1.975-5.051-1.14-6.837z"
            fill="#010101"
          />
          <path
            id="Vector_33"
            d="M368.497 252.055c-.195.279.027 1.339.305 2.371.279 1.033.891 1.647 1.03 3.349.139 1.674.166 1.897-.306 2.874-.473.976-.612 1.87 1.029 1.898 1.641.027 2.531-.028 4.2.223 1.668.251 2.252.335 3.17.195.918-.139 1.113-.446.724-.725-.39-.279-2.003-.586-2.698-1.145-.668-.502-2.559-1.339-2.587-1.562-.083-.754-.111-3.488.028-4.381.139-.893.333-2.177.389-2.512.056-.334.334-.669-.139-.558-.473.112-2.253.363-3.588.279-1.335-.083-1.474-.39-1.557-.306z"
            fill="#8AC640"
          />
          <path
            id="Vector_34"
            opacity={0.3}
            d="M369.442 260.677c.473.223 1.168.391 1.697.391 0 0-.195.921.111 1.479s-2.225.223-2.225.223l-.111-1.981.528-.112zm7.371 2.4c.445-.14.751-.642.389-1.116-.389-.475-.723-.558-.222-.586.501-.028 2.336 1.088 2.336 1.088l-.946.865-1.557-.251zm-8.4-9.934c.64.223 1.613.279 2.448.251.834-.028 2.086-.14 2.892-.419.807-.279.473.307.473.307l-.445.419s-1.057.419-2.781.391c-2.03-.028-2.642-.251-2.642-.251l.055-.698zm.056 1.395c.64.224 1.613.279 2.447.251.835-.027 1.947-.027 2.754-.334.334-.112.139.362.139.362l-.139.251s-1.085.391-2.781.363c-2.031-.028-2.392-.195-2.392-.195l-.028-.698z"
            fill="#010101"
          />
          <path
            id="Vector_35"
            d="M366.633 234.977c0 .196 2.17 1.284 3.365 1.507 1.197.223 3.7 0 4.089-.084l-.056.391s-2.976.447-5.256-.167c-2.281-.614-2.031-.754-2.031-.754l-.111-.893z"
            fill="#010101"
          />
          <path
            id="Vector_36"
            d="M361.988 258.78c.334.167 1.53.474 2.309.307.111-.028 0-1.926.306-2.791.445-1.2 1.168-2.176 1.501-4.297a17.42 17.42 0 01-3.198-.642c-.89 2.735-.584 5.079-.918 7.423zm1.864 1.758c.194.055.333.279.389.139.111-.251-.195-.725-.222-1.06v-.028c-.251-.223-1.947-.251-1.836-.14-.195.363-.501.307-.612 1.033-.055.363.39.056.807.028-.751.502-1.613 1.144-1.753 1.702-.166.781.112 1.005.946 1.423.723.168 1.586.196 2.253.168.751-.14.89-.503.668-1.005-.334-.753-.557-1.73-.64-2.26z"
            fill="#F0EFEF"
          />
          <path
            id="Vector_37"
            d="M364.158 224.29c.918.53 2.197.391 2.67.363.111 0 1.224-.196 1.279-.168.111.028.111.112.111.112s-.417.223-1.362.279c-.89.055-1.947 0-2.531-.279-.696-.307-.167-.307-.167-.307zm9.456.53c.167.111 1.252.53 1.725 1.032.417.447.195.419.111.307-.111-.139-.973-.725-1.307-.865-.334-.139-.751-.39-.751-.446 0-.056.222-.028.222-.028z"
            fill="#010101"
          />
          <path
            id="Vector_38"
            d="M364.018 236.4c.807-.056 1.642.14 2.17.698.278.279.723.586.668.865 0 .084-.167.307-.306.474a6.527 6.527 0 01-.418.447c-.111.083-.5.39-.584.446-.083.056-.194.196-.278.223-.278.14-.584.028-.862-.111-.278-.14.056-.168-.25-.391-.751-.53-1.168-.893-.862-1.925.027-.196.333-.419.722-.726z"
            fill="#F0EFEF"
          />
          <path
            id="Vector_39"
            opacity={0.4}
            d="M356.926 230.01c-2.503 1.005-8.873 4.186-10.68 5.163 1.502.948 2.197 3.236 2.419 5.553.028.223.056.418.084.641.028.196.055.335.083.419 0 .028 0 .084.028.112 1.641-4.493 7.51-9.237 7.732-9.6.111-.167-.139-.892.251-1.59.5-.893 1.474-1.284.083-.698zm5.952 21.068c1.28-2.567 1.307-5.023 1.28-7.897 0-1.2.862-2.902.417-2.428-1.669 1.87-5.869 5.386-8.901 5.581 4.256-.139 5.925 2.009 7.204 4.744z"
            fill="#010101"
          />
          <path
            id="Vector_40"
            d="M343.798 237.544c1.585-1.144 9.79-5.525 11.765-6.139 1.975-.641 1.363-1.395 1.363-1.395s-8.01 3.46-12.794 6.446"
            fill="#010101"
          />
          <path
            id="Vector_41"
            opacity={0.4}
            d="M367.161 229.48c-.639-.251-1.14.502-.973 1.228.167.726 1.669 1.535 1.585 4.186-.055 2.176-.528 3.069-.528 3.069l-1.057-1.339s-.167-3.014-.528-3.46c-.362-.447-1.502-1.256-1.947-1.675-.445-.418.5-.976.445-1.758-.056-.753.473-2.26.473-2.26l2.53 2.009zm3.867 11.887c-.056 2.093.417 5.19.612 6.669.194 1.479.445 1.591 0 2.261-.445.642-1.029 1.702-1.029 1.702l-1.92-.168s1.53-1.953 1.613-2.316c.084-.362-.778-3.125-.778-3.125l1.502-5.023zm-3.7-19.533c.39.865.863 1.256 1.614 1.507.445.168 2.197.391 2.892-.391.306-.362.111-1.339.111-1.339l-1.585 1.284-2.142-.391-.25-.642-.64-.028z"
            fill="#010101"
          />
          <g id="Vector_42">
            <path
              d="M367.495 223.76c.723.474 2.531.921 3.032 1.004.501.112 1.307-.53 1.697-.697.417-.196 1.14-.307 1.974.446.084.084-.194.447-.194.447-.028-.028-.195-.028-.418-.14-.222-.112-.417-.195-.751-.167-1.39.167-1.613.641-2.837.362-1.223-.279-1.529-.502-2.725-.446"
              fill="#8AC640"
            />
            <path
              d="M367.495 223.76c.723.474 2.531.921 3.032 1.004.501.112 1.307-.53 1.697-.697.417-.196 1.14-.307 1.974.446.084.084-.194.447-.194.447-.028-.028-.195-.028-.418-.14-.222-.112-.417-.195-.751-.167-1.39.167-1.613.641-2.837.362-1.223-.279-1.529-.502-2.725-.446"
              stroke="#010101"
              strokeMiterlimit={10}
              strokeLinejoin="round"
            />
          </g>
          <path
            id="Vector_43"
            d="M367.245 223.843c.918.391 2.698.81 3.198.921.501.112 1.308-.39 1.697-.642.696-.446 1.585-.083 2.003.391.278.307.389.502.389.586 0 .112-.333 0-.333 0-.195-.084-.418-.111-.585-.223-.222-.112-.445-.279-.778-.251-1.391.167-1.669.641-2.865.362-1.196-.279-1.502-.53-2.781-.446"
            fill="#8AC640"
          />
          <path
            id="Vector_44"
            d="M362.934 249.906c-.056-.056.055-.112 0-.112-.362 0-.862-.279-1.141-.669-1.196-1.73-2.948-2.874-6.119-2.791-4.756.112-6.647-1.841-7.009-5.581-.194-2.037-.751-4.018-1.891-5.134l-.668.419c1.28 1.116 1.697 2.93 1.975 5.413.445 3.739 3.449 5.469 6.954 5.525 3.643.056 4.95.809 6.313 2.651.445.586.946.781 1.335.865l.251-.586z"
            fill="#010101"
          />
          <path
            id="Vector_45"
            opacity={0.4}
            d="M375.839 231.964c.084.418.306 1.227.751 1.618.195.195.223.251.056.251s-1.391-.056-1.391-.056l-.333-.586.917-1.227z"
            fill="#010101"
          />
        </g>
        <g id="Group_5">
          <path
            id="Vector_46"
            d="M907.782 498.908s2.14 8.28 2.14 10.37.517 3.49-3.981 4.36c-4.497.87-7.462.35-8.159-1.74-.696-2.09-1.214-12.57-1.214-12.57l10.946-2.1.268 1.68z"
            fill="#fff"
            stroke="#263238"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_47"
            d="M897.832 511.908a8.754 8.754 0 01-.299-1.46 73.335 73.335 0 0012.458-1c0 2 .388 3.35-3.98 4.19-4.368.84-7.512.36-8.179-1.73z"
            fill="#fff"
            stroke="#263238"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_48"
            d="M802.26 499.688s-3.473 1.22-8.517 2.79c-5.045 1.57-15.314 3.32-16.309 3.49-.995.17-.995 2.27-.169 3.15.826.88 5.383 3.49 10.766 4.88 5.383 1.39 23.632 2.62 25.194 1.58 1.304-.88.866-9.43.348-11.35-.517-1.92-11.313-4.54-11.313-4.54z"
            fill="#fff"
            stroke="#263238"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_49"
            d="M777.245 509.118a2.626 2.626 0 01-.517-2.45c3.522 2.82 10.557 5.92 17.711 6.64a127.36 127.36 0 0019.503-.1c-.13 1.2-.359 2.11-.737 2.37-1.562 1-19.801-.18-25.194-1.58-5.393-1.4-9.9-4.01-10.766-4.88z"
            fill="#fff"
            stroke="#263238"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_50"
            d="M886.29 347.478s2.985 18.26.676 28.4c0 0 4.368 40.22 5.045 58.14 0 0 9.413 31.44 10.766 41.24a242.503 242.503 0 005.005 23.65 21.246 21.246 0 01-6.726 2.37c-4.717 1-5.383-2.71-5.383-2.71s-25.871-59.83-27.921-68.62c-2.049-8.79-8.726-40.21-8.726-40.21l-27.861 51.38s-1.353 17.58-5.383 27.72-11.771 38.19-11.771 38.19a27.753 27.753 0 01-9.084-1c-4.04-1.35-4.04-3.38-4.04-3.38s6.059-22.65 6.059-30.08 2.349-32.79 4.03-39.89c1.682-7.1 13.125-44.28 14.806-48.34 1.682-4.06 5.383-16.9 5.383-16.9l2.349-19.95s28.895 8.11 52.776-.01z"
            fill="#111827"
            stroke="#fff"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_51"
            d="M864.946 261.328s1.553-3.37 1.553-5.44c0-2.07.995-11.91.995-11.91s-14.926-27.17-19.055-32.35a63.385 63.385 0 00-9.015-9.06s-10.05-2.07-12.109-2.07c-2.06 0-4.379-1-4.379-2.33s3.354-1 5.413-1c2.06 0 4.637-1.81 4.637-1.81s-3.353-9.65-4.378-13.46c-.547-2-2.318-6.21-.995-6.21s1.542 1 2.318 2.59c.777 1.59 4.12 6.73 4.12 6.73l-.766-11.39s.995-1.55 1.801.26a78.355 78.355 0 012.577 8.54 6.266 6.266 0 001.283 2.46l.995-8.49s1.752-1.87 2.06 1.37c.169 1.8 0 7.77 0 8.8 0 1.03.995-1.47.995-1.47s.607-2.81 1.284-3.19c.676-.38 1.283.52.995 2.59-.289 2.07.258 10.61.258 10.61s1.543 2.07 3.861 4.92c2.319 2.85 20.896 19.67 27.861 25.11 6.965 5.44 7.721 9.84 8.756 15.27 1.035 5.43 2.06 37 2.06 48.41 0 11.41-.995 29.5-1.801 35.46-.806 5.96.617 13.64 1.612 17.82.995 4.18 0 7.76-2.836 9.83-2.836 2.07-14.926 3.37-24.975 3.37-10.05 0-20.349-1-23.443-2.07-3.095-1.07-5.463-1.31-5.463-5.44 0-4.13 2.06-12.42 2.06-14.75s-4.129-26.4-4.129-26.4-26.269 8-31.164 6.21c-4.896-1.79-45.841-40.64-45.841-40.64s-6.438-2.59-9.791-3.11c-3.353-.52-8.498-2.84-8.756-3.62-.259-.78.517-.52 2.577-.52a24.14 24.14 0 015.413 1s-7.035-4.48-8.249-4.92c-.836-.31-2.279-2.22-.259-1.81 2.537.51 8.756 2.33 8.756 2.33l-8.238-5.18s-1.284-2.07.258-2.07c1.543 0 9.274 4.66 9.274 4.66l-5.97-5.62c-1.164-1.08-.189-2.61 1.184-1.81l6.965 4c1.698.998 3.5 1.806 5.373 2.41l1.284.78a34.506 34.506 0 01-.518-4.14c0-1.3.776-4.66 2.577-4.92 1.801-.26.259 2.33.259 3.62s2.577 8 2.577 9.06v3.11s8.756 7.76 16.736 11.91c7.981 4.15 26.02 17.86 26.02 17.86s20.597-10.62 25.234-14.5c4.637-3.88 9.791-8.54 14.925-12.68a63.939 63.939 0 018.498-6l16.726-.71z"
            fill="#fff"
            stroke="#263238"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_52"
            d="M778.877 280.558c8.746 5.62 20.657 14.68 20.657 14.68s20.596-10.62 25.233-14.5c4.637-3.88 9.791-8.54 14.926-12.68a63.929 63.929 0 018.497-6l16.736-.77s1.553-3.37 1.553-5.44c0-2.07.995-11.91.995-11.91s-7.712-14-13.582-23.85l.467-.48c2.886-2.89 6.876-4.45 10.358-5.3 4.856 4.33 9.682 8.5 12.548 10.74 6.965 5.43 7.721 9.84 8.756 15.27 1.035 5.43 2.06 37 2.06 48.41 0 11.41-.995 29.5-1.801 35.46-.806 5.96.607 13.72 1.602 17.9.995 4.18 0 7.76-2.836 9.83-2.836 2.07-14.926 3.37-24.975 3.37-10.05 0-20.349-1-23.443-2.07-3.095-1.07-5.463-1.31-5.463-5.44 0-4.13 2.06-12.42 2.06-14.75s-4.129-26.4-4.129-26.4-26.269 8-31.164 6.21c-2.607-1-15.523-12.5-26.976-23a35.345 35.345 0 017.921-9.28z"
            fill="#fff"
            stroke="#263238"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_53"
            d="M837.135 272.668s10.368 2.84 10.946 10.73"
            stroke="#263238"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_54"
            d="M829.176 306.628s12.079-3.34 18.358-9.66"
            stroke="#263238"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_55"
            d="M835.882 304.908s10.368 2.84 19.791-.94"
            stroke="#263238"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_56"
            d="M879.623 288.138s-3.274 23-19.055 34.46"
            stroke="#263238"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_57"
            d="M855.593 328.908c-1.204.33-2.448.62-3.731.85"
            stroke="#263238"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_58"
            d="M879.623 311.108a44.344 44.344 0 01-17.662 15.36"
            stroke="#263238"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_59"
            d="M882.678 260.048s-10.05-5-16.02-.32"
            stroke="#263238"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_60"
            d="M879.852 237.008s-9.114 3.16-11.622 9.47"
            stroke="#263238"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_61"
            d="M873.882 234.798a12.904 12.904 0 00-4.398 6.94"
            stroke="#263238"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_62"
            d="M830.956 219.908s-1.552 8.8-1.552 11.13 2.577 3.11 1.552 6.21c-1.024 3.1-3.353 3.37-2.835 6 .517 2.63 3.86 4.14 3.86 4.14s1.801 7.25 3.612 10.35c1.811 3.1 8.498.78 8.498.78l.517 8.28s2.319 3.37 10.816 2.33a46.98 46.98 0 0014.159-3.88l1.294-1.81s-6.697-3.37-6.965-5.7c-.269-2.33 0-7.76 0-15.53s2.318-22.78-10.299-26.66c-12.617-3.88-22.657 4.36-22.657 4.36z"
            fill="#fff"
            stroke="#263238"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_63"
            d="M846.688 241.158s2.905-6.7 6.159-2.87c2.109 2.49-.518 9.84-1.801 10.87-1.284 1.03-4.12.52-4.12.52s4.12 4.14 8.498 4.14c4.378 0 8.239-4.14 11.074-11.39 2.836-7.25 4.896-19.67 1.801-27.18-3.094-7.51-19.064-7.76-22.666-7.76-3.602 0-9.015 2.07-9.015 2.07s-11.592-1-11.851 2.85c-.259 3.85 1.552 4.14 1.552 4.14s-8.248 4.4-4.378 6.21c3.871 1.81 9.781.78 13.652.78a5.5 5.5 0 012.979.676 5.534 5.534 0 012.165 2.164s-3.602 2.33-2.318 3.37c1.283 1.04 5.97 3.1 6.438 4.92.467 1.82-1.801 4.66-.249 6 1.552 1.34 2.08.49 2.08.49z"
            fill="#111827"
          />
          <path
            id="eye"
            d="M832.359 238.028c0 1.32.548 2.39 1.214 2.39.667 0 1.204-1.07 1.204-2.39s-.547-2.39-1.204-2.39c-.656 0-1.214 1.07-1.214 2.39z"
            fill="#263238"
          />
          <path
            id="Vector_64"
            d="M836.578 234.978s-1.661-3.9-4.298-1.81"
            stroke="#263238"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_65"
            d="M859.046 389.738l2.358-4.4 11.771-3.04"
            stroke="#fff"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <g id="Group_6">
          <path
            id="Vector_66"
            d="M246.9 466.9s0-4.32-6.06-10.38c-6.06-6.06-10-9.52-10-9.52s-3 10 2.59 16a106.202 106.202 0 0013.42 11.68l.05-7.78z"
            fill="#92E3A9"
          />
          <path
            id="Vector_67"
            d="M238.11 493.96s0-4.33-6.06-10.39c-6.06-6.06-9.99-9.52-9.99-9.52s-3 10 2.59 16a107.274 107.274 0 0013.42 11.68l.04-7.77z"
            fill="#92E3A9"
          />
          <path
            id="Vector_68"
            d="M246.52 474.3s.46-4.3 7.12-9.68 10.9-8.42 10.9-8.42 2 10.22-4.27 15.65a106.232 106.232 0 01-14.57 10.2l.82-7.75z"
            fill="#92E3A9"
          />
          <path
            id="Vector_69"
            d="M235.9 506.22s.9-4.23 8.1-8.88c7.2-4.65 11.72-7.23 11.72-7.23s.88 10.37-5.89 15.11a106.192 106.192 0 01-15.57 8.62l1.64-7.62z"
            fill="#92E3A9"
          />
          <path
            id="Vector_70"
            d="M237.89 541.02s0-4.33 6.06-10.39c6.06-6.06 10-9.52 10-9.52s3 10-2.59 16a106.825 106.825 0 01-13.42 11.69l-.05-7.78z"
            fill="#92E3A9"
          />
          <path
            id="Vector_71"
            d="M237.79 549.51s.62-4.28-4.52-11.14-8.5-10.84-8.5-10.84-4.41 9.43.3 16.22a105.34 105.34 0 0011.62 13.47l1.1-7.71z"
            fill="#92E3A9"
          />
          <path
            id="Vector_72"
            d="M231.82 574.69s0-4.33 6.06-10.39c6.06-6.06 10-9.52 10-9.52s3 9.95-2.6 16a105.744 105.744 0 01-13.41 11.68l-.05-7.77z"
            fill="#92E3A9"
          />
          <path
            id="Vector_73"
            d="M235.86 597.51s-1.09-4.19 3.2-11.61c4.29-7.42 7.22-11.73 7.22-11.73s5.45 8.86 1.55 16.14a106.267 106.267 0 01-10 14.7l-1.97-7.5z"
            fill="#92E3A9"
          />
          <path
            id="Vector_74"
            d="M247.45 465.83a124.24 124.24 0 01-1.66 13.43c-2.4 12.37-8.38 20.36-10.78 31.53-2.4 11.17 4.48 25.58 2.64 39.93-1.84 14.35-7.43 22.34-5.83 31.92 1.6 9.58 10 35.52 10 35.52"
            stroke="#fff"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_75"
            d="M246.46 477.18l6.53-5.01"
            stroke="#fff"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_76"
            d="M246.76 471.41l-2.73-4.86"
            stroke="#fff"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_77"
            d="M235.37 510.28s5.47-4.1 11.09-8.2"
            stroke="#fff"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_78"
            d="M238.11 501.75s-4.56-8.93-9.72-14.85"
            stroke="#fff"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_79"
            d="M238.11 547.18a67.406 67.406 0 0111.69-15.64"
            stroke="#fff"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_80"
            d="M237.06 553.25a76.786 76.786 0 00-5.93-11.24c-3.18-4.7-3.64-5.31-3.64-5.31"
            stroke="#fff"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_81"
            d="M231.82 582.64a73.29 73.29 0 014.92-10 63.59 63.59 0 016.38-8.35"
            stroke="#fff"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_82"
            d="M237.84 605.04a18.578 18.578 0 011.63-9.58c2.28-4.41 4.86-10.17 5.93-12.45"
            stroke="#fff"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_83"
            d="M207.23 524.74s-.47-2.71 2.67-7.17c3.14-4.46 5.21-7.05 5.21-7.05s3 5.92.11 10.33a67.311 67.311 0 01-7.16 8.78l-.83-4.89z"
            fill="#92E3A9"
          />
          <path
            id="Vector_84"
            d="M215.67 540.74s-.46-2.72 2.68-7.17c3.14-4.45 5.2-7.05 5.2-7.05s3 5.91.11 10.32a67.675 67.675 0 01-7.14 8.78l-.85-4.88z"
            fill="#92E3A9"
          />
          <path
            id="Vector_85"
            d="M208.27 529.33s-.76-2.65-5.52-5.31c-4.76-2.66-7.75-4.12-7.75-4.12s-.12 6.62 4.38 9.35a67.52 67.52 0 0010.24 4.81l-1.35-4.73z"
            fill="#92E3A9"
          />
          <path
            id="Vector_86"
            d="M218.39 548.19s-1-2.56-6-4.7-8.14-3.25-8.14-3.25.58 6.59 5.34 8.83a68.283 68.283 0 0010.69 3.72l-1.89-4.6z"
            fill="#92E3A9"
          />
          <path
            id="Vector_87"
            d="M220.92 570.22s-.47-2.71-4.93-5.85c-4.46-3.14-7.27-4.89-7.27-4.89s-.82 6.57 3.36 9.76a67.936 67.936 0 009.68 5.87l-.84-4.89z"
            fill="#92E3A9"
          />
          <path
            id="Vector_88"
            d="M221.9 575.54s-.84-2.64 1.63-7.48c2.47-4.84 4.15-7.72 4.15-7.72s3.79 5.43 1.58 10.21a67.857 67.857 0 01-5.83 9.7l-1.53-4.71z"
            fill="#92E3A9"
          />
          <path
            id="Vector_89"
            d="M229.51 597.43s.31-2.74 4.58-6.13c4.27-3.39 7-5.29 7-5.29s1.2 6.51-2.8 9.93a68.012 68.012 0 01-9.33 6.41l.55-4.92z"
            fill="#92E3A9"
          />
          <path
            id="Vector_90"
            d="M228.38 590.68s-.47-2.72-4.92-5.86-7.28-4.92-7.28-4.92-.82 6.57 3.37 9.76a67.26 67.26 0 009.68 5.87l-.85-4.85z"
            fill="#92E3A9"
          />
          <path
            id="Vector_91"
            d="M228.32 605.43s.24-2.75-3.28-6.91c-3.52-4.16-5.8-6.58-5.8-6.58s-2.46 6.15.79 10.3a68.23 68.23 0 007.87 8.13l.42-4.94z"
            fill="#92E3A9"
          />
          <path
            id="Vector_92"
            d="M206.76 524.11a81.612 81.612 0 002.5 8.24c2.85 7.5 7.47 11.86 10.18 18.61s0 16.52 2.68 25.32 7.09 13.2 7.12 19.38c.03 6.18-2.4 23.36-2.4 23.36"
            stroke="#fff"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_93"
            d="M208.62 531.12l-4.64-2.43"
            stroke="#fff"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_94"
            d="M207.8 527.54l1.19-3.35"
            stroke="#fff"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_95"
            d="M219.16 550.68s-3.87-2-7.84-3.94"
            stroke="#fff"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_96"
            d="M216.52 545.62a56.004 56.004 0 014.48-10.37"
            stroke="#fff"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_97"
            d="M221.45 574.11a42.846 42.846 0 00-9-8.54"
            stroke="#fff"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_98"
            d="M222.78 577.8a48.38 48.38 0 012.49-7.69c1.49-3.29 1.71-3.73 1.71-3.73"
            stroke="#fff"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_99"
            d="M229.06 600.35a40.933 40.933 0 015-5.18 26.335 26.335 0 003.24-2.81"
            stroke="#fff"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_100"
            d="M229.24 595.66a45.816 45.816 0 00-4.16-5.7 39.976 39.976 0 00-4.91-4.55"
            stroke="#fff"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_101"
            d="M227.9 610.37a11.853 11.853 0 00-2.06-5.84c-1.91-2.51-4.16-5.85-5.07-7.16"
            stroke="#fff"
            strokeWidth={1.035}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_102"
            d="M214.47 616.03h39.59v29.81a3 3 0 01-3 3h-33.55a3 3 0 01-3-3v-29.81h-.04z"
            stroke="#fff"
          />
          <path
            id="Vector_103"
            d="M253.75 621.2h-39.28a3.102 3.102 0 01-3.1-3.11 3.101 3.101 0 013.1-3.1h39.28a3.101 3.101 0 013.1 3.1 3.088 3.088 0 01-.904 2.198 3.091 3.091 0 01-2.196.912z"
            fill="#fff"
          />
        </g>
        <path
          id="Vector_104"
          d="M786.96 257.4v1.02h-1.02"
          stroke="#fff"
          strokeWidth={1.023}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_105"
          d="M783.92 258.42h-59.49"
          stroke="#fff"
          strokeWidth={1.023}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="2.02 2.02"
        />
        <path
          id="Vector_106"
          d="M723.42 258.42h-1.03v-1.02"
          stroke="#fff"
          strokeWidth={1.023}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_107"
          d="M722.39 255.43v-46.27"
          stroke="#fff"
          strokeWidth={1.023}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="1.97 1.97"
        />
        <path
          id="Vector_108"
          d="M722.39 208.17v-1.02h1.03"
          stroke="#fff"
          strokeWidth={1.023}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_109"
          d="M725.43 207.15h59.5"
          stroke="#fff"
          strokeWidth={1.023}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="2.02 2.02"
        />
        <path
          id="Vector_110"
          d="M785.94 207.15h1.02v1.02"
          stroke="#fff"
          strokeWidth={1.023}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_111"
          d="M786.96 210.14v46.28"
          stroke="#fff"
          strokeWidth={1.023}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="1.97 1.97"
        />
        <path
          id="Vector_112"
          d="M776.65 215.34H732.7v34.9h43.95v-34.9z"
          fill="#fff"
          stroke="#fff"
          strokeWidth={1.023}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_113"
          d="M730.12 212.75l-15.08-11.63"
          stroke="#fff"
          strokeWidth={1.023}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_114"
          d="M779.67 251.96l12.93 11.2"
          stroke="#fff"
          strokeWidth={1.023}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_115"
          d="M714.44 204.95L714 200h5.17"
          stroke="#fff"
          strokeWidth={1.023}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_116"
          d="M792.95 258.48l.89 5.4-6.29.23"
          stroke="#fff"
          strokeWidth={1.023}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_117"
          d="M722.1 265.72h23.19"
          stroke="#fff"
          strokeWidth={1.023}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_118"
          d="M722.1 270.94h23.19"
          stroke="#fff"
          strokeWidth={1.023}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g id="Group_18">
          <path
            id="Path_25"
            d="M288.181 649.625h38.569c1.429 0 2.689-.969 3.1-2.384l11.005-37.174c.625-2.149-.837-5.067-3.007-5.067l-38.663.084c-1.429 0-2.689.969-3.101 2.384l-11.004 37.844a3.44 3.44 0 00.502 2.962 3.205 3.205 0 002.599 1.351z"
            fill="#009AB6"
          />
          <path
            id="Path_26"
            d="M286.238 649.625h38.569c1.429 0 2.689-.969 3.101-2.384l11.004-37.844a3.44 3.44 0 00-.502-2.962 3.205 3.205 0 00-2.599-1.351h-38.569c-1.429 0-2.689.969-3.101 2.384l-11.004 37.844a3.44 3.44 0 00.503 2.962 3.201 3.201 0 002.598 1.351z"
            fill="#00D8FF"
          />
          <g id="reactjs-icon_1" clipPath="url(#clip4)">
            <g id="Group_7">
              <path
                id="Vector_119"
                d="M310.164 630.715c-1.661 0-3.008-1.392-3.008-3.11s1.347-3.11 3.008-3.11c1.66 0 3.007 1.392 3.007 3.11s-1.347 3.11-3.007 3.11z"
                fill="#fff"
              />
              <g
                id="Group_8"
                fillRule="evenodd"
                clipRule="evenodd"
                stroke="#fff"
                strokeWidth={2}
              >
                <path
                  id="Vector_120"
                  d="M310.163 621.281c-4.037 0-7.788.599-10.616 1.606-3.407 1.214-5.502 3.053-5.502 4.718 0 1.735 2.22 3.689 5.879 4.943 2.767.948 6.407 1.442 10.239 1.442 3.93 0 7.651-.464 10.448-1.453 3.54-1.251 5.671-3.23 5.671-4.932 0-1.652-2-3.477-5.359-4.688-2.839-1.024-6.682-1.636-10.759-1.636h-.001z"
                />
                <path
                  id="Vector_121"
                  d="M315.486 624.461c-2.017-3.617-4.393-6.678-6.649-8.709-2.718-2.447-5.305-3.405-6.7-2.573-1.453.867-1.98 3.832-1.202 7.737.587 2.952 1.992 6.461 3.906 9.894 1.963 3.521 4.211 6.623 6.437 8.635 2.816 2.546 5.538 3.467 6.964 2.617 1.383-.825 1.912-3.529 1.249-7.144-.561-3.055-1.968-6.804-4.004-10.457h-.001z"
                />
                <path
                  id="Vector_122"
                  d="M315.481 630.82c2.023-3.614 3.4-7.272 3.975-10.307.692-3.658.202-6.455-1.191-7.289-1.452-.87-4.199.139-7.082 2.786-2.179 2.001-4.417 5.012-6.337 8.442-1.968 3.517-3.444 7.081-4.018 10.08-.726 3.795-.138 6.694 1.286 7.547 1.382.828 3.911-.049 6.608-2.449 2.278-2.028 4.716-5.161 6.759-8.81v0z"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
      <g clipPath="url(#clip5)" id="Frame_24">
        <rect x={567} y={134} width={37} height={37} rx={4} fill="#233950" />
        <g id="figma-1_1" clipPath="url(#clip6)" filter="url(#filter2_d)">
          <path
            id="path0_fill"
            d="M581.14 166.243c2.553 0 4.624-2.052 4.624-4.581v-4.581h-4.624c-2.552 0-4.624 2.052-4.624 4.581 0 2.529 2.072 4.581 4.624 4.581z"
            fill="#0ACF83"
          />
          <path
            id="path1_fill"
            d="M576.516 152.5c0-2.529 2.072-4.581 4.624-4.581h4.624v9.162h-4.624c-2.552 0-4.624-2.052-4.624-4.581z"
            fill="#A259FF"
          />
          <path
            id="path1_fill_1"
            d="M576.517 143.338c0-2.529 2.071-4.581 4.624-4.581h4.624v9.162h-4.624c-2.553 0-4.624-2.052-4.624-4.581z"
            fill="#F24E1E"
          />
          <path
            id="path2_fill"
            d="M585.764 138.757h4.624c2.553 0 4.624 2.052 4.624 4.581 0 2.529-2.071 4.581-4.624 4.581h-4.624v-9.162z"
            fill="#FF7262"
          />
          <path
            id="path3_fill"
            d="M595.012 152.5c0 2.529-2.071 4.581-4.624 4.581-2.552 0-4.624-2.052-4.624-4.581 0-2.529 2.072-4.581 4.624-4.581 2.553 0 4.624 2.052 4.624 4.581z"
            fill="#1ABCFE"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0">
        <path
          fill="#fff"
          transform="rotate(-24.663 1464.712 -523.355)"
          d="M0 0h49v52H0z"
        />
      </clipPath>
      <clipPath id="clip1">
        <path
          fill="#fff"
          transform="translate(440 166)"
          d="M0 0h40.444v9.333H0z"
        />
      </clipPath>
      <clipPath id="clip2">
        <path
          fill="#fff"
          transform="translate(416 403.007)"
          d="M0 0h34v34H0z"
        />
      </clipPath>
      <clipPath id="clip3">
        <path
          fill="#fff"
          transform="translate(337.818 215)"
          d="M0 0h43v50H0z"
        />
      </clipPath>
      <clipPath id="clip4">
        <path
          fill="#fff"
          transform="matrix(-1 0 0 1 327.001 610.219)"
          d="M0 0h33.675v34.83H0z"
        />
      </clipPath>
      <clipPath id="clip5">
        <rect x={567} y={134} width={37} height={37} rx={4} fill="#fff" />
      </clipPath>
      <clipPath id="clip6">
        <path
          fill="#fff"
          transform="translate(576.514 138.757)"
          d="M0 0h18.5v27.486H0z"
        />
      </clipPath>
      <filter
        id="filter0_d"
        x={337}
        y={532.007}
        width={96.229}
        height={97.703}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={7.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
      <filter
        id="filter1_d"
        x={401}
        y={392.007}
        width={64}
        height={64}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={7.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
      <filter
        id="filter2_d"
        x={561.514}
        y={127.757}
        width={48.5}
        height={57.486}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={7.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
    </defs>
  </svg>
);

export default HeroImage;
